import { Component, OnInit, ViewChild } from "@angular/core";
import { RestService } from "../rest.service";
import { Router } from "@angular/router";
import { catchError, retry } from "rxjs/operators";
import moment from 'moment';
import 'moment-timezone';
import { ScheduleTabsComponent } from "../schedule-tabs/schedule-tabs.component";
import { JobScheduleResponse, MaintenanceScheduleRes } from "src/models/Table";
import { SchedulerUtils } from "../utils/scheduler.utils";
import { Subject } from "rxjs";

@Component({
  selector: "app-schedule",
  templateUrl: "./schedule.component.html",
  styleUrls: ["./schedule.component.css"],
})
export class ScheduleComponent implements OnInit {
  activeDictorySelected: boolean = true;
  oktaSelected: boolean = false;
  cardnumber: string = "";
  expireDate: string = "";
  graphWidth: any = 0;
  cvv: string = "";
  envList: any = [];
  jobList: any = [];

  isLoading: boolean = false;
  isJobModelShown: boolean = false;
  isMaintenanceModelShown: boolean = false;
  isNonRecurringSelected: boolean = true;
  isRecurringSelected: boolean = false;
  isRunNowSelected: boolean = false;
  isEnvSelected: boolean = false;
  isSoonestAvlSelected: boolean = true;
  isSoonestpdtSelected: boolean = false;
  isSpecificdtSelected: boolean = false;

  jobScheduleResponse: JobScheduleResponse;
  mScheduleResponse: MaintenanceScheduleRes;

  nrs1: boolean = true;
  nrs2: boolean = false;
  nrs3: boolean = false;
  nrs4: boolean = false;
  rs1: boolean = false;
  rs2: boolean = false;
  rs3: boolean = false;
  rs4: boolean = false;
  nrs1pb: boolean = false;
  nrs2pb: boolean = false;
  nrs3pb: boolean = false;
  nrs4pb: boolean = false;

  mts1: boolean = false;
  mts2: boolean = false;
  mts3: boolean = false;
  mts4: boolean = false;
  mstep1: boolean = true;
  mstep2: boolean = false;
  mstep3: boolean = false;
  mstep4: boolean = false;

  nrjEnvironment: any = "";
  nrjjob: any = "";
  nrjdescription: any = "";
  rjseries: any = "";
  nrjpath: any = "";
  nrjalias: any = "";
  rjRepeatType: any = "1";
  dayfrequency: any = "";
  weekfrequency: any = "";
  monthfrequency: any = "";
  yearfrequency: any = "";
  monthofyear: any = "1";
  rangestart: any = "";
  rangeend: any = "";
  rangeEndAfterValue: any = "1";
  expandRowId: any = "";
  masterEnvId: any = "";

  isnrjEnvironmentError: boolean = false;
  isnrjjobError: boolean = false;
  isSeriesEmpty: boolean = false;
  isnrjdescriptionError: boolean = false;
  isrjRepeatTypeEmpty: boolean = false;
  isDayOneSelected: boolean = true;
  isDayTwoSelected: boolean = false;
  isdayfrequencyEmpty: boolean = false;
  isWeekOneSelected: boolean = true;
  isWeekTwoSelected: boolean = false;
  isweekfrequencyEmpty: boolean = false;
  isWeekTwoMonSelected: boolean = true;
  isWeekTwoTueSelected: boolean = false;
  isWeekTwoWedSelected: boolean = false;
  isWeekTwoThuSelected: boolean = false;
  isWeekTwoFriSelected: boolean = false;
  isWeekTwoSatSelected: boolean = false;
  isWeekTwoSunSelected: boolean = false;
  isMonthOneSelected: boolean = true;
  isMonthTwoSelected: boolean = false;
  isMonthThreeSelected: boolean = false;
  ismonthfrequencyEmpty: boolean = false;
  isMonthThreeOneSelected: boolean = true;
  isMonthThreeSecSelected: boolean = true;
  isMonthThreeThrSelected: boolean = true;
  isMonthThreefourSelected: boolean = true;
  isMonthThreelastSelected: boolean = true;
  isyearfrequencyEmpty: boolean = false;
  isRangeStartShown: boolean = false;
  isRangeEndShown: boolean = false;
  isRepeatMonthSelected: boolean = false;
  isRangeEndOn: boolean = true;
  isRangeEndAfter: boolean = false;
  isParticularDay: boolean = true;
  isSpecifictime: boolean = false;
  israngeEndAfterValueEmpty: boolean = false;
  isDateInvalid: boolean = false;
  israngeDateError: boolean = false;

  isCardNumberEmpty: boolean = false;
  isexpireDateEmpty: boolean = false;
  iscvvEmpty: boolean = false;
  currentJob: any;

  url: any = "";
  basedn: any = "";
  username: any = "";
  password: any = "";
  isUrlEmpty: boolean = false;
  isBasednEmpty: boolean = false;
  isUsernameEmpty: boolean = false;
  isPasswordEmpty: boolean = false;

  oktaorgurl: any = "";
  oktatoken: any = "";
  isOktaorgurlEmpty: boolean = false;
  isOktatokenEmpty: boolean = false;

  lastLogin: any;
  isCardInfoProvided: any;

  isCardModelShown: boolean;
  islastLogin: boolean;
  isSetUpModelShown: boolean;
  isSuperAdmin: any = "";

  isSuccess: boolean = false;
  isFailure: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";

  isADFailure: boolean = false;
  adFailureMessage: any = "";
  isOktaFailure: boolean = false;
  oktaFailureMessage: any = "";

  hours: any;
  minutes: any;
  estHours: any;
  estMintues: any;
  estHoursSelection: any = 0;
  estMinuteSelection: any = 0;
  envMachineList: any;
  startType: any;
  machineId: any = "";
  editMachineId: any = "";
  startDateArray: any = [];
  headerobj: any = "";
  tableobj: any = [];
  occurance: any = [];
  machineobj: any = [];
  editedStartDateArray: any = [];
  startDate: any = "";
  tphours: any = "00";
  tshours:any = '00';
  tsminutes:any="00";
  tpminutes: any = "00";
  tptype: any = "AM";
  estEditHours: any;
  estEditMintues: any;
  estEditHoursSelection: any = 0;
  estEditMinuteSelection: any = 0;
  saveFrequency: any = "";

  disableIncreaseHours: boolean = false;
  disableDecreaseHours: boolean = false;
  disableIncreaseMinutes: boolean = false;
  disableDecreaseMinutes: boolean = false;
  isSmartMatchChecked: boolean = false;
  isTimepickerInvalid: boolean = false;
  isEstimatedDurationInvalid: boolean = false;
  isMachineIdInvalid: boolean = false;
  isLoadingIcon: boolean = false;
  isExpand: boolean = false;
  isReviewDateShown: boolean = false;
  isReviewTimeShown: boolean = false;
  disableIncreaseHrs: boolean = false;
  disableDecreaseHrs: boolean = false;
  disableIncreaseMins: boolean = false;
  disableDecreaseMins: boolean = false;

  maintenanceSingleSelection: boolean = false;
  maintenanceSeriesSelection: boolean = false;
  maintenanceSingleDetails: boolean = false;
  maintenanceSeriesDetails: boolean = false;
  maintenanceSingleReview: boolean = false;
  maintenanceSeriesReview: boolean = false;

  isDifferentTimezone: boolean = false;
  timezoneInfo: boolean = false;

  mSingle2Data: any = "";
  mSingle3Data: any = "";
  mSeries2Data: any = "";
  mSeries3Data: any = "";

  extendMaintenanceTable: boolean;

  selectedTimeZone: string = "";
  localTimeZone: string = "";
  mtnRecurringRes:any = [];

  // Stripe
  showStripePayment: boolean = false;
  clientSecret: string;
  stripeIntentId: string;
  initiatePayment: Subject<boolean> = new Subject();

  @ViewChild(ScheduleTabsComponent, { static: false })
  child: ScheduleTabsComponent;

  constructor(private _restService: RestService, private router: Router) { }

  ngOnInit() {

    this.selectedTimeZone = localStorage.getItem('selectedTimeZone');
    this.localTimeZone = localStorage.getItem('localTimeZone');

    this.checkTimezone();

    this.islastLogin =
      localStorage.getItem("LastLogin") === "null" ? true : false;
    this.isCardModelShown =
      localStorage.getItem("isCardInfoProvided") === "0" ? true : false;
   
    this.isSetUpModelShown = localStorage.getItem("isSetUpInfoProvided") === "0" ? true : false;
    // this.isSetUpModelShown = true;
    
    this.isSuperAdmin = localStorage.getItem("isSuper");

    localStorage.getItem("isAATokenLoaded") === "false"
      ? ((this.isLoading = true),
        this._restService
          .aaLogin()
          .pipe(
            catchError((e) => {
              this.isLoading = false;
              console.log("err first--->", e);
              localStorage.getItem("LastLogin") !== "null"
                ? ((this.isFailure = true),
                  (this.failureMessage = e.error.StatusInfo))
                : "";
              return e;
            })
          )
          .subscribe(
            (f: any) => (
              (this.isLoading = false),
              console.log("AAToken", f),
              localStorage.setItem("isAATokenLoaded", "true")
              //  localStorage.setItem("AAToken", f.token.token)
              // localStorage.setItem("AATokenLoaded", ""),
            )
          ))
      : "";

    this._restService
      .environmentList()
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => ((this.envList = f.EnvList), (this.isLoading = false))
      );

    var dt = new Date();
    var h = dt.getHours(),
      m = dt.getMinutes();
    var _time = h > 12 ? "PM" : "AM";
    this.hours = h >= 10 ? h : "0" + h;
    this.minutes = m >= 10 ? m : "0" + m;
    this.rangestart = dt;
    this.rangeend = dt;
    localStorage.setItem(
      "singleDate",
      (
        new Date(dt).getDate() +
        "/" +
        (new Date(dt).getMonth() + 1) +
        "/" +
        new Date(dt).getFullYear()
      ).toString()
    );

    localStorage.setItem(
      "startRange",
      (
        new Date(dt).getDate() +
        "/" +
        (new Date(dt).getMonth() + 1) +
        "/" +
        new Date(dt).getFullYear()
      ).toString()
    );

    localStorage.setItem(
      "endRange",
      (
        new Date(dt).getDate() +
        "/" +
        (new Date(dt).getMonth() + 1) +
        "/" +
        new Date(dt).getFullYear()
      ).toString()
    );

    this.estHours = Array(25)
      .fill(0)
      .map((x, i) => i);
    this.estMintues = Array(60)
      .fill(0)
      .map((x, i) => i);

    this.estEditHours = Array(25)
      .fill(0)
      .map((x, i) => i);
    this.estEditMintues = Array(60)
      .fill(0)
      .map((x, i) => i);

    localStorage.setItem("windowWidth", window.innerWidth.toString());

    // To do Activate on Super Admin sign up
    if (false) {
      this.setUpStripe();
    }
  }

  setUpStripe() {
    this.showStripePayment = false;
    this.isLoading = true;
    this.isFailure = false;

    this._restService
      .setupPaymentIntent(localStorage.getItem("email"))
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isFailure = true;
          this.isLoading = false;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (f: any) => {
          this.isLoading = false;
          this.clientSecret = f.clientSecret;
          this.stripeIntentId = f.intentId;
          this.showStripePayment = true;
        }
      );
  }
  //Schedule page code

  jobModel() {
    this.isJobModelShown = true;
    this.isMaintenanceModelShown = false;
  }

  closeJobModelShown() {
    this.isJobModelShown = false;
    this.isNonRecurringSelected = true;
    this.isRecurringSelected = false;
    this.isRunNowSelected = false;
    this.nrs1 = true;
    this.nrs2 = false;
    this.nrs3 = false;
    this.nrs4 = false;
    this.rs2 = false;
    this.rs3 = false;
    this.rs4 = false;
    this.nrs1pb = false;
    this.nrs2pb = false;
    this.nrs3pb = false;
    this.isnrjEnvironmentError = false;
    this.isnrjjobError = false;
    this.isnrjdescriptionError = false;
    this.isSeriesEmpty = false;

    this.envList = [];
    this.jobList = [];
    this.isEnvSelected = false;
    this.nrjEnvironment = "";
    this.nrjjob = "";
    this.nrjpath = "";
    this.nrjalias = "";
    this.nrjdescription = "";
    this.rjseries = "";

    localStorage.setItem("selectedDates", "");
    localStorage.setItem("mSingleDate", "");
    this.isSoonestAvlSelected = true;
    this.isSoonestpdtSelected = false;
    this.isSpecificdtSelected = false;
    this.hours = "00";
    this.minutes = "00";
    this.isTimepickerInvalid = false;
    this.estHoursSelection = 0;
    this.estMinuteSelection = 0;
    this.isEstimatedDurationInvalid = false;
    this.machineId = "";
    this.isMachineIdInvalid = false;
    this.isSmartMatchChecked = false;
    this.isDateInvalid = false;
    this.isReviewDateShown = false;
    this.isReviewTimeShown = false;

    this.rjRepeatType = "1";
    this.isParticularDay = true;
    this.isSpecifictime = false;
  }

  maintenanceModel() {
    this.isMaintenanceModelShown = true;
    this.isJobModelShown = false;

    this.mstep1 = true;
    this.mts1 = false;
    this.mts2 = false;
    this.mts3 = false;
    this.mts4 = false;
    this.maintenanceSingleSelection = false;
    this.maintenanceSeriesSelection = false;
    this.maintenanceSingleDetails = false;
    this.maintenanceSeriesDetails = false;
    this.maintenanceSingleReview = false;
    this.maintenanceSeriesReview = false;
  }

  closeMaintenanceModelShown() {
    this.isMaintenanceModelShown = false;
  }

  runNowEvent(e: any) {
    e.target.checked === true
      ? ((this.isRunNowSelected = true),
        (this.isRecurringSelected = false),
        this.isNonRecurringSelected = false)
      : (this.isRunNowSelected = false);
  }

  nonRecurringEvent(e: any) {
    e.target.checked === true
      ? ((this.isNonRecurringSelected = true),
        (this.isRecurringSelected = false),
        this.isRunNowSelected = false)
      : (this.isNonRecurringSelected = false);
  }

  recurringEvent(e: any) {
    e.target.checked === true
      ? ((this.isRecurringSelected = true),
        (this.isNonRecurringSelected = false),
        this.isRunNowSelected = false)
      : (this.isRecurringSelected = false);
  }

  nrs1Event() {
    this.isLoadingIcon = true;
    this.isNonRecurringSelected || this.isRunNowSelected
      ? ((this.nrs1 = false), (this.nrs2 = true), (this.nrs1pb = true))
      : this.isRecurringSelected === true
        ? ((this.nrs1 = false), (this.rs2 = true), (this.nrs1pb = true))
        : "";

    this._restService
      .environmentList()
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => ((this.envList = f.EnvList), (this.isLoadingIcon = false))
      );
  }

  nrs2Event() {
    this.isLoadingIcon = true;
    this.nrjEnvironment === ""
      ? (this.isnrjEnvironmentError = true)
      : (this.isnrjEnvironmentError = false);

    this.nrjjob === ""
      ? (this.isnrjjobError = true)
      : (this.isnrjjobError = false);

    this.nrjdescription === ""
      ? (this.isnrjdescriptionError = true)
      : (this.isnrjdescriptionError = false);

    if (
      this.nrjEnvironment !== "" &&
      this.nrjjob !== "" &&
      this.nrjdescription !== ""
    ) {
      this.nrs2 = false;
      this.nrs3 = true;
      this.nrs2pb = true;
    }

    this.isSoonestAvlSelected = true;
    this.isSoonestpdtSelected = false;
    this.isSpecificdtSelected = false;
    localStorage.setItem("selectedDates", "");
    localStorage.setItem("mSingleDate", "");

    this._restService
      .getEnvMachineList(this.nrjEnvironment, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.envMachineList = f.EnvMachineList),
          (this.isLoadingIcon = false),
          console.log(this.envMachineList)
        )
      );
  }

  rs2Event() {
    this.isLoadingIcon = true;
    this.dayfrequency = "";
    this.weekfrequency = "";
    this.monthfrequency = "";
    this.yearfrequency = "";
    this.isdayfrequencyEmpty = false;
    this.isweekfrequencyEmpty = false;
    this.ismonthfrequencyEmpty = false;
    this.isyearfrequencyEmpty = false;
    this.rjRepeatType = "1";
    this.isParticularDay = true;
    this.isSpecifictime = false;
    this.estHoursSelection = 0;
    this.estMinuteSelection = 0;
    this.isEstimatedDurationInvalid = false;
    this.machineId = "";
    this.isMachineIdInvalid = false;
    this.isSmartMatchChecked = false;

    this.nrjEnvironment === ""
      ? (this.isnrjEnvironmentError = true)
      : (this.isnrjEnvironmentError = false);

    this.nrjjob === ""
      ? (this.isnrjjobError = true)
      : (this.isnrjjobError = false);

    this.nrjdescription === ""
      ? (this.isnrjdescriptionError = true)
      : (this.isnrjdescriptionError = false);

    this.rjseries === ""
      ? (this.isSeriesEmpty = true)
      : (this.isSeriesEmpty = false);

    if (
      this.nrjEnvironment !== "" &&
      this.nrjjob !== "" &&
      this.nrjdescription !== "" &&
      this.rjseries !== ""
    ) {
      this.rs2 = false;
      this.rs3 = true;
      this.nrs2pb = true;

      this._restService
        .getEnvMachineList(this.nrjEnvironment, this.masterEnvId)
        .pipe(
          catchError((e) => {
            (this.isLoadingIcon = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            (this.envMachineList = f.EnvMachineList),
            (this.isLoadingIcon = false),
            console.log(this.envMachineList)
          )
        );
    } else {
      this.isLoadingIcon = false;
    }
  }

  nrjEnvironmentEvent(e: any) {
    this.isLoadingIcon = true;
    this.isnrjEnvironmentError = false;
    this.nrjjob = "";
    this.nrjpath = "";
    this.nrjalias = "";

    e.target.value === ""
      ? (this.isEnvSelected = false)
      : (this.isEnvSelected = true);
    this.nrjEnvironment = e.target.value;

    this.envList.filter((m: any) =>
      parseInt(m.id) === parseInt(this.nrjEnvironment)
        ? (this.masterEnvId = m.MasterEnvId)
        : ""
    );

    this._restService
      .getEnvBotList(this.nrjEnvironment, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.jobList = f.EnvBotList),
          console.log("JobList", this.jobList),
          (this.isLoadingIcon = false)
        )
      );
  }

  nrjjobEvent(id: any) {
    this.nrjjob = id;
    this.isnrjjobError = false;
    this.jobList.filter((f: any) =>
      parseInt(f.BotId) === parseInt(id)
        ? ((this.nrjpath = f.BotPath),
          (this.nrjalias = f.Alias === null ? "---" : f.Alias))
        : ""
    );

    this.currentJob = this.jobList.find(f => parseInt(f.BotId) === parseInt(id));
  }

  nrjbacktostep1() {
    this.envList = [];
    // this.nrjEnvironment = "";
    this.isnrjEnvironmentError = false;
    this.jobList = [];
    this.isnrjjobError = false;
    this.nrjpath = "";
    this.nrjalias = "";
    this.rjseries = "";
    this.nrjdescription = "";
    this.isnrjdescriptionError = false;
    this.isSeriesEmpty = false;

    this.nrs1 = true;
    this.nrs2 = false;
    this.rs2 = false;
    this.nrs1pb = false;
    this.isnrjEnvironmentError = false;
    this.isnrjjobError = false;
    this.isnrjdescriptionError = false;
    this.isSeriesEmpty = false;
    this.isNonRecurringSelected = true;
    this.isRecurringSelected = false;
    this.dayfrequency = "";
    this.weekfrequency = "";
    this.monthfrequency = "";
    this.yearfrequency = "";
  }

  nrjbacktostep2() {
    this.isSoonestAvlSelected = true;
    this.isSoonestpdtSelected = false;
    this.isSpecificdtSelected = false;
    this.hours = "00";
    this.minutes = "00";
    this.isTimepickerInvalid = false;
    this.estHoursSelection = 0;
    this.estMinuteSelection = 0;
    this.machineId = "";
    this.isSmartMatchChecked = false;
    this.isMachineIdInvalid = false;
    this.isDateInvalid = false;

    // this.nrjEnvironment = "";
    this.isnrjEnvironmentError = false;
    this.jobList = [];
    this.nrjjob = "";
    this.isnrjjobError = false;
    this.nrjpath = "";
    this.nrjalias = "";
    this.nrjdescription = "";
    this.isnrjdescriptionError = false;
    this.nrjEnvironment = "";
    this.nrjjob = "";
    this.nrjdescription = "";

    this.nrs1 = false;
    this.nrs2 = true;
    this.nrs3 = false;
    this.nrs2pb = false;
    this.isTimepickerInvalid = false;
    this.isEstimatedDurationInvalid = false;
    this.isMachineIdInvalid = false;
    this.isDateInvalid = false;
  }

  rjbacktostep2() {
    // this.nrjEnvironment = "";
    this.isnrjEnvironmentError = false;
    this.jobList = [];
    this.isnrjjobError = false;
    this.nrjpath = "";
    this.nrjalias = "";
    this.isSeriesEmpty = false;
    this.isnrjdescriptionError = false;
    this.nrjEnvironment = "";
    this.nrjjob = "";
    this.rjseries = "";
    this.nrjdescription = "";

    this.rs1 = false;
    this.rs2 = true;
    this.rs3 = false;
    this.nrs2pb = false;
  }

  nrjbacktostep3() {
    this.isSoonestAvlSelected = true;
    this.isSoonestpdtSelected = false;
    this.isSpecificdtSelected = false;
    this.hours = "00";
    this.minutes = "00";
    this.isTimepickerInvalid = false;
    this.estHoursSelection = 0;
    this.estMinuteSelection = 0;
    this.machineId = "";
    this.isSmartMatchChecked = false;
    this.isMachineIdInvalid = false;
    this.isDateInvalid = false;

    this.nrs1 = false;
    this.nrs2 = false;
    this.nrs3 = true;
    this.nrs4 = false;
    this.nrs3pb = false;
  }

  rjbacktostep3() {
    this.rjRepeatType = "1";
    this.isParticularDay = true;
    this.isSpecifictime = false;
    this.estHoursSelection = 0;
    this.estMinuteSelection = 0;
    this.isEstimatedDurationInvalid = false;
    this.machineId = "";
    this.isMachineIdInvalid = false;
    this.isSmartMatchChecked = false;
    this.isDateInvalid = false;

    this.dayfrequency = "";
    this.weekfrequency = "";
    this.monthfrequency = "";
    this.yearfrequency = "";

    this.rs2 = false;
    this.rs3 = true;
    this.rs4 = false;
    this.nrs3pb = false;
  }

  soonestAvlEvent(e: any) {
    this.isSoonestAvlSelected = true;
    this.isSoonestpdtSelected = false;
    this.isSpecificdtSelected = false;
    localStorage.setItem("selectedDates", "");
  }

  soonestpdtEvent(e: any) {
    this.isSoonestAvlSelected = false;
    this.isSoonestpdtSelected = true;
    this.isSpecificdtSelected = false;
    localStorage.setItem("selectedDates", "");
  }

  specificdtEvent(e: any) {
    this.isSoonestAvlSelected = false;
    this.isSoonestpdtSelected = false;
    this.isSpecificdtSelected = true;
  }

  increaseHours() {
    var hrs = parseInt(this.hours) + 1;
    this.disableDecreaseHours = false;
    if (hrs === 24) {
      this.disableIncreaseHours = true;
      this.disableIncreaseMinutes = true;
      this.disableDecreaseMinutes = true;
      this.hours = "24";
      this.minutes = "00";
    } else {
      this.disableIncreaseHours = false;
      this.hours = hrs >= 10 ? hrs : "0" + hrs;
    }
  }

  decreaseHours() {
    var hrs = parseInt(this.hours) - 1;
    this.disableIncreaseHours = false;
    this.disableIncreaseMinutes = false;
    if (hrs === 0) {
      this.disableDecreaseHours = true;
      this.hours = "00";
    } else {
      this.disableDecreaseHours = false;
      this.hours = hrs >= 10 ? hrs : "0" + hrs;
    }
  }

  increaseMinutes() {
    var mins = parseInt(this.minutes) + 1;
    this.disableDecreaseMinutes = false;
    if (mins > 59) {
      this.disableIncreaseMinutes = true;
    } else {
      this.disableIncreaseMinutes = false;
      this.minutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  decreaseMinutes() {
    var mins = parseInt(this.minutes);
    this.disableIncreaseMinutes = false;
    if (mins === 0) {
      this.disableDecreaseMinutes = true;
      this.minutes = "00";
    } else {
      mins = parseInt(this.minutes) - 1;
      this.disableDecreaseMinutes = false;
      this.minutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  estHoursEvent(e: any) {
    this.isEstimatedDurationInvalid = false;
    var hrs = parseInt(e.target.value);
    if (hrs === 24) {
      this.estMinuteSelection = 0;
      this.estMintues = Array(1)
        .fill(0)
        .map((x, i) => i);
    } else {
      this.estMintues = Array(60)
        .fill(0)
        .map((x, i) => i);
    }
  }

  estMinutesEvent(e: any) {
    this.isEstimatedDurationInvalid = false;
  }

  estEditHoursEvent(e: any) {
    var hrs = parseInt(e.target.value);
    if (hrs === 24) {
      this.estEditMinuteSelection = 0;
      this.estEditMintues = Array(1)
        .fill(0)
        .map((x, i) => i);
    } else {
      this.estEditMintues = Array(60)
        .fill(0)
        .map((x, i) => i);
    }
  }

  estEditMinutesEvent(e: any) {
    var mins = parseInt(e.target.value);
    var hrs = this.estEditHoursSelection;
    if (hrs === 0) {
      this.isFailure = true;
      this.failureMessage = "Should be greater than 0";
    }
  }

  onChangeMachine(e: any) {
    this.machineId = e.target.value;
    this.editMachineId = e.target.value;
    this.isMachineIdInvalid = false;
    this.isSmartMatchChecked = false;
  }

  smartMatch(e: any) {
    e.target.checked
      ? ((this.isSmartMatchChecked = true),
        (this.isMachineIdInvalid = false),
        (this.machineId = "0"))
      : ((this.isSmartMatchChecked = false), (this.machineId = ""));
  }

  nrs3Event() {
    this.isLoadingIcon = true;
    this.checkTimezone();
    this.nrs3pb = true;
    console.log("envId", this.nrjEnvironment);
    console.log("botId", this.nrjjob);
    console.log("scheduleDesc", this.nrjdescription);

    var selectDate = localStorage.getItem("selectedDates");
    selectDate = selectDate.substring(1);

    this.startType = this.isSoonestAvlSelected
      ? "1"
      : this.isSoonestpdtSelected
        ? "2"
        : this.isSpecificdtSelected
          ? "3"
          : "";
    console.log("startType", this.startType);
    if (!this.isSoonestAvlSelected) {
      var sd = localStorage.getItem('selectedDates');

      var ds = sd.split(",");
      var sdt = ds.map((m: any) => (m = m.split("/").reverse().join("-")));
      var filtered = sdt.filter(function (el) {
        return el != "";
      });

    console.log("dates selected--->" , ds);


      var hhmm = this.hours + ":" + this.minutes;
      var spdt = filtered.map(
        (m: any) => (m = m.split("/").reverse().join("-") + " " + hhmm)
      );
    }



    this.startDateArray = this.isSoonestAvlSelected
      ? []
      : this.isSoonestpdtSelected
        ? filtered
        : this.isSpecificdtSelected
          ? spdt
          : [];

    console.log("est hours selection---", this.estHoursSelection);
    console.log("machineId", this.machineId);

    if (
      this.isSpecificdtSelected &&
      parseInt(this.hours) === 0 &&
      parseInt(this.minutes) === 0
    ) {
      this.isTimepickerInvalid = true;
    } else {
      this.isTimepickerInvalid = false;
    }

    if (
      parseInt(this.estHoursSelection) === 0 &&
      parseInt(this.estMinuteSelection) === 0
    ) {
      this.isEstimatedDurationInvalid = true;
    } else {
      this.isEstimatedDurationInvalid = false;
    }

    if (!this.isSmartMatchChecked && this.machineId === "") {
      this.isMachineIdInvalid = true;
    } else {
      this.isMachineIdInvalid = false;
    }

    console.log("startdate array----" , this.startDateArray);
    

    // var selectDates = localStorage.getItem('selectedDates').length;
    this.isSoonestpdtSelected || this.isSpecificdtSelected
      ? selectDate !== ""
        ? (this.isDateInvalid = false)
        : (this.isDateInvalid = true)
      : (this.isDateInvalid = false);

    if (
      !this.isTimepickerInvalid &&
      !this.isEstimatedDurationInvalid &&
      !this.isMachineIdInvalid &&
      !this.isDateInvalid
    ) {
      this.nrs3 = false;
      this.nrs4 = true;
      this._restService
        .createJobSchedule(
          this.nrjEnvironment,
          this.nrjjob,
          this.nrjdescription,
          this.startType,
          this.startDateArray,
          this.machineId,
          this.estHoursSelection,
          this.estMinuteSelection,
          this.isSmartMatchChecked,
          false,
          0,
          this.masterEnvId
        )
        .pipe(
          catchError((e) => {
            (this.isLoadingIcon = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => {
            this.jobScheduleResponse = f;
            console.log("createJobSchedule ------>", f.scheduleListRes);
            (this.tableobj = []);
            (this.headerobj = f.scheduleListRes.Header);
            (this.machineobj = f.scheduleListRes.machineList);
            (this.tableobj = f.scheduleListRes.OccuranceTable);
            this.tableobj.filter((m: any) => (m.isfold = false));
            this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1));
            if (this.startType == 2){
              this.updateSoonestParticularDate();
              f.scheduleListRes.OccuranceTable = this.tableobj;
            }
            this.tableobj.filter(
              (m: any, index: any) => (
                (m.startDateBefore = m.NewStart),
                (m.endDateBefore = m.NewEnd),
                (m.NewStart = this.timezoneConvert(m.NewStart)),
                (m.NewEnd = this.timezoneConvert(m.NewEnd)),
                console.log("end 12", m.startDateBefore)
              ),
            );
            this.tableobj.filter((m: any) =>
              SchedulerUtils.updateScheduleObject(m)
            );
            console.log("table 2", this.tableobj);
            this.isLoadingIcon = false;
        });
    } else {
      this.isLoadingIcon = false;
    }
  }

  updateSoonestParticularDate(){
    let foundDates = [];

    this.tableobj = this.tableobj.filter(tEntry => {

      if (tEntry.selectedDate == tEntry.requestDate){
        return true;
      }

      foundDates.push(tEntry.requestDate);
      return false;
    });

    if (foundDates.length > 0){
      console.log(foundDates);
      this.failureMessage = `We could not find slots for the following dates \n ${foundDates.join(", ")}`;
      this.isFailure = true;
    }
  }

  convertToTimezone(d: any) {
    var dt = new Date(d);

    var offset = dt.getTimezoneOffset();
    dt.setMinutes(dt.getMinutes() + offset);

    var timezone: any = parseInt(localStorage.getItem("timezone"));

    console.log("timezone", offset, timezone);

    if (Math.abs(offset) !== Math.abs(timezone)) {
      let tz = new Date(dt.setMinutes(dt.getMinutes() + timezone));
      console.log("trueeeeeeee");
      return (
        tz.getFullYear().toString().padStart(4, "0") +
        "-" +
        (tz.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        tz.getDate().toString().padStart(2, "0") +
        " " +
        tz.getHours().toString().padStart(2, "0") +
        ":" +
        tz.getMinutes().toString().padStart(2, "0") +
        ":" +
        tz.getSeconds().toString().padStart(2, "0")
      );
    } else {
      console.log("falseeeeeee");
      return d;
    }
  }

  checkTimezone() {
    var dt = new Date();
    var offset = dt.getTimezoneOffset();
    var timezone: any = parseInt(localStorage.getItem("timezone"));

    if (Math.abs(offset) !== Math.abs(timezone)) {
      this.isDifferentTimezone = true;
      this.timezoneInfo = true;
    } else {
      this.isDifferentTimezone = false;
      this.timezoneInfo = false;
    }
  }

  rs3Event() {
    this.isLoadingIcon = true;
    this.checkTimezone();
    var repeatOption: any;
    var rjRepeatType1 = false;

    console.log("envId", this.nrjEnvironment);
    console.log("botId", this.nrjjob);
    console.log("seriesName", this.rjseries);
    console.log("seriesDescription", this.nrjdescription);
    console.log("repeatType", this.rjRepeatType);
    console.log("dayfrequency", this.dayfrequency);

    // Day
    if (this.rjRepeatType === "1" && this.isDayOneSelected) {
      if (this.dayfrequency === "") {
        this.isdayfrequencyEmpty = true;
      } else {
        rjRepeatType1 = true;
        repeatOption = {
          frequency: parseInt(this.dayfrequency),
          onWeekday: 0,
        };
      }
    } else if (this.rjRepeatType === "1" && this.isDayTwoSelected) {
      rjRepeatType1 = true;
      repeatOption = {
        frequency: 0,
        onWeekday: 1,
      };
    }

    // Week
    if (this.rjRepeatType === "2" && this.isWeekOneSelected) {
      if (this.weekfrequency === "") {
        this.isweekfrequencyEmpty = true;
      } else {
        rjRepeatType1 = true;
        repeatOption = {
          frequency: parseInt(this.weekfrequency),
          daysofweek: 0,
          isfrequency: true,
        };
      }
    } else if (this.rjRepeatType === "2" && this.isWeekTwoSelected) {
      rjRepeatType1 = true;
      repeatOption = {
        frequency: 0,
        daysofweek: this.isWeekTwoMonSelected
          ? 2
          : this.isWeekTwoTueSelected
            ? 3
            : this.isWeekTwoWedSelected
              ? 4
              : this.isWeekTwoThuSelected
                ? 5
                : this.isWeekTwoFriSelected
                  ? 6
                  : this.isWeekTwoSatSelected
                    ? 0
                    : this.isWeekTwoSunSelected
                      ? 1
                      : "",
        isfrequency: false,
      };
    }

    // Month
    if (this.rjRepeatType === "3" && this.isMonthOneSelected) {
      if (this.monthfrequency === "") {
        this.ismonthfrequencyEmpty = true;
      } else {
        rjRepeatType1 = true;
        repeatOption = {
          frequency: parseInt(this.monthfrequency),
          dateofmonth: 0,
          daysofweek: {
            weekindex: 0,
            dayindex: 0,
          },
          isfrequency: true,
          isdateofmonth: false,
        };
      }
    } else if (this.rjRepeatType === "3" && this.isMonthTwoSelected) {
      var d = localStorage.getItem("singleDate");
      var date = new Date(d).getDate();
      rjRepeatType1 = true;
      repeatOption = {
        frequency: 0,
        dateofmonth: parseInt(d),
        daysofweek: {
          weekindex: 0,
          dayindex: 0,
        },
        isfrequency: false,
        isdateofmonth: true,
      };
    } else if (this.rjRepeatType === "3" && this.isMonthThreeSelected) {
      var d = localStorage.getItem("singleDate");
      var date = new Date(d).getDate();
      rjRepeatType1 = true;
      repeatOption = {
        frequency: 0,
        dateofmonth: parseInt(d),
        daysofweek: {
          weekindex: this.isMonthThreeOneSelected
            ? 1
            : this.isMonthThreeSecSelected
              ? 2
              : this.isMonthThreeThrSelected
                ? 3
                : this.isMonthThreefourSelected
                  ? 4
                  : this.isMonthThreelastSelected
                    ? 0
                    : "",
          dayindex: this.isWeekTwoMonSelected
            ? 2
            : this.isWeekTwoTueSelected
              ? 3
              : this.isWeekTwoWedSelected
                ? 4
                : this.isWeekTwoThuSelected
                  ? 5
                  : this.isWeekTwoFriSelected
                    ? 6
                    : this.isWeekTwoSatSelected
                      ? 0
                      : this.isWeekTwoSunSelected
                        ? 1
                        : "",
        },
        isfrequency: false,
        isdateofmonth: false,
      };
    }

    // Year
    if (this.rjRepeatType === "4" && this.isMonthOneSelected) {
      if (this.yearfrequency === "") {
        this.isyearfrequencyEmpty = true;
      } else {
        rjRepeatType1 = true;
        repeatOption = {
          frequency: parseInt(this.yearfrequency),
          dateofyear: {
            date: 0,
            month: 0,
          },
          daysofweekofmonth: {
            monthindex: 0,
            weekindex: 0,
            dayindex: 0,
          },
          isfrequency: true,
          isdateofyear: false,
        };
      }
    } else if (this.rjRepeatType === "4" && this.isMonthTwoSelected) {
      var d = localStorage.getItem("singleDate");
      var getDate = d.split("/").reverse().join("-");

      rjRepeatType1 = true;
      repeatOption = {
        frequency: 0,
        dateofyear: {
          date: new Date(getDate).getDate(),
          month: new Date(getDate).getMonth() + 1,
        },
        daysofweekofmonth: {
          monthindex: parseInt(this.monthofyear),
          weekindex: this.isMonthThreeOneSelected
            ? 1
            : this.isMonthThreeSecSelected
              ? 2
              : this.isMonthThreeThrSelected
                ? 3
                : this.isMonthThreefourSelected
                  ? 4
                  : this.isMonthThreelastSelected
                    ? 0
                    : "",
          dayindex: this.isWeekTwoMonSelected
            ? 2
            : this.isWeekTwoTueSelected
              ? 3
              : this.isWeekTwoWedSelected
                ? 4
                : this.isWeekTwoThuSelected
                  ? 5
                  : this.isWeekTwoFriSelected
                    ? 6
                    : this.isWeekTwoSatSelected
                      ? 0
                      : this.isWeekTwoSunSelected
                        ? 1
                        : "",
        },
        isfrequency: false,
        isdateofyear: true,
      };
    } else if (this.rjRepeatType === "4" && this.isMonthThreeSelected) {
      var d = localStorage.getItem("singleDate");
      var d = localStorage.getItem("singleDate");
      var getDate = d.split("/").reverse().join("-");

      rjRepeatType1 = true;
      repeatOption = {
        frequency: 0,
        dateofyear: {
          date: new Date(getDate).getDate(),
          month: new Date(getDate).getMonth() + 1,
        },
        daysofweekofmonth: {
          monthindex: parseInt(this.monthofyear),
          weekindex: this.isMonthThreeOneSelected
            ? 1
            : this.isMonthThreeSecSelected
              ? 2
              : this.isMonthThreeThrSelected
                ? 3
                : this.isMonthThreefourSelected
                  ? 4
                  : this.isMonthThreelastSelected
                    ? 0
                    : "",
          dayindex: this.isWeekTwoMonSelected
            ? 2
            : this.isWeekTwoTueSelected
              ? 3
              : this.isWeekTwoWedSelected
                ? 4
                : this.isWeekTwoThuSelected
                  ? 5
                  : this.isWeekTwoFriSelected
                    ? 6
                    : this.isWeekTwoSatSelected
                      ? 0
                      : this.isWeekTwoSunSelected
                        ? 1
                        : "",
        },
        isfrequency: false,
        isdateofyear: false,
      };
    }

    var sr = localStorage.getItem("startRange").split("/").reverse().join("-");
    var er = localStorage.getItem("endRange").split("/").reverse().join("-");

    var range = {
      startdate: sr,
      end: {
        enddate: er,
        occurances: parseInt(this.rangeEndAfterValue),
        isOccurance: this.isRangeEndAfter,
      },
    };

    var timePattern = {
      soonestBydate: this.isParticularDay,
      atParticularTime:
        this.tptype === "AM"
          ? (this.tphours + ":" + this.tpminutes).toString()
          : (parseInt(this.tphours) + 12 + ":" + this.tpminutes).toString(),
    };

    console.log("repeatOption", repeatOption);
    console.log("range", range);
    console.log("timePattern", timePattern);

    if (!this.isRangeEndAfter) {
      if (new Date(sr) >= new Date(er)) {
        this.israngeDateError = true;
      } else {
        this.israngeDateError = false;
      }
    } else {
      this.israngeDateError = false;
    }

    if (
      parseInt(this.estHoursSelection) === 0 &&
      parseInt(this.estMinuteSelection) === 0
    ) {
      this.isEstimatedDurationInvalid = true;
    } else {
      this.isEstimatedDurationInvalid = false;
    }

    if (!this.isSmartMatchChecked && this.machineId === "") {
      this.isMachineIdInvalid = true;
    } else {
      this.isMachineIdInvalid = false;
    }

    // this.rangeEndAfterValue === ""
    //   ? (this.israngeEndAfterValueEmpty = true)
    //   : (this.israngeEndAfterValueEmpty = false);

    console.log("envId", this.nrjEnvironment);
    console.log("botId", this.nrjjob);
    console.log("seriesName", this.rjseries);
    console.log("seriesDescription", this.nrjdescription);
    console.log("repeatType", this.rjRepeatType);
    console.log("dayfrequency", this.dayfrequency);
    console.log("repeatOption", repeatOption);
    console.log("range", range);
    console.log("timePattern", timePattern);

    if (
      rjRepeatType1 &&
      !this.isEstimatedDurationInvalid &&
      !this.isMachineIdInvalid &&
      !this.israngeDateError
    ) {
      this._restService
        .createJobRecurringSchedule(
          this.nrjEnvironment,
          this.nrjjob,
          this.rjseries,
          this.nrjdescription,
          this.rjRepeatType,
          repeatOption,
          range,
          timePattern,
          this.estHoursSelection,
          this.estMinuteSelection,
          this.machineId,
          this.isSmartMatchChecked,
          this.masterEnvId
        )
        .pipe(
          catchError((e) => {
            (this.isLoadingIcon = false),
              (this.isFailure = true),
              console.log(e.error),
              console.log(e),
              (this.failureMessage = e.error.response
                ? e.error.response
                : e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            (this.rs2 = false),
            (this.rs3 = false),
            (this.rs4 = true),
            (this.nrs2pb = true),
            (this.nrs3pb = true),
            (this.tableobj = []),
            (this.headerobj = f.RecurringRes.Header),
            this.jobScheduleResponse = new JobScheduleResponse(),
            this.jobScheduleResponse.scheduleListRes = f.RecurringRes,
            (this.saveFrequency = f.RecurringRes.Header.frequency),
            console.log("this.saveFrequency", this.saveFrequency),
            (this.machineobj = f.RecurringRes.machineList),
            (this.tableobj = f.RecurringRes.OccuranceTable),
            this.tableobj.filter((m: any) => (m.isfold = false)),
            this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
            this.tableobj.filter(
              (m: any, index: any) => (
                (m.startDateBefore = m.NewStart),
                (m.endDateBefore = m.NewEnd),
                (m.NewStart = this.timezoneConvert(m.NewStart)),
                (m.NewEnd = this.timezoneConvert(m.NewEnd)),
                console.log("end 13", m.startDateBefore)
              )
            ),
            console.log("table 1 --->>>", this.tableobj),
            this.tableobj.
            filter((m: any) =>
              SchedulerUtils.updateScheduleObject(m)
            ),
            
            (this.isLoadingIcon = false),
            console.log("Save Job Schedule", f.RecurringRes)
          )
        );
    } else {
      this.isLoadingIcon = false;
    }
  }

  nrs4Event() {
    console.log("entry");

    this.isLoadingIcon = true;
    var occ = [];
    var count = 0;
    var findDuplicates: any = [];

    console.log("FlaggedMID", this.tableobj);

    //   this.tableobj.filter((d:any) =>
    //   d.hasOwnProperty("scheduleArr")
    //   ? d.scheduleArr.filter((m:any)=>

    //   (console.log("pushing start date",JSON.stringify(m)))
    //   )
    //   :""
    // )

    var t = this.tableobj.filter((m: any) =>
      m.hasOwnProperty("scheduleArr")
        ? m.scheduleArr.filter((d: any) =>
          d.IsNew === true
            ? ((d.machineId = m.machineId),
              (d.Status = m.Status),
              (d.flagged = m.flagged))
            : ""
        )
        : ""
    );

    this.tableobj.filter((m: any) =>
      m.hasOwnProperty("flaggedMid")
        ? m.hasOwnProperty("scheduleArr")
          ? m.scheduleArr.filter((d: any) => (d.flaggedMid = m.flaggedMid))
          : ""
        : ""
    );

    console.log("FlaggedMID 2", this.tableobj);

    this.tableobj.filter((m: any) =>
      m.hasOwnProperty("scheduleArr")
        ? m.scheduleArr.filter((d: any) =>
          d.IsNew === true ? occ.push(d) : ""
        )
        : ""
    );

    this.occurance = occ;
    console.log("TableObj ------->>>>>>", this.tableobj);
    console.log("occurance ------->>>>>>", occ);

    // this.timezoneInfo
    // ? this.tableobj.filter((m: any) =>
    //   m.hasOwnProperty("scheduleArr")
    //     ? m.scheduleArr.filter(
    //       (d: any) => (
    //         (d.ctstartDate = d.ctstartDate), (d.ctendDate = d.ctendDate)
    //       )
    //     )
    //     : ""
    // )
    // : null;


    // this.timezoneInfo
    //   ? this.tableobj.filter((m: any) =>
    //     m.hasOwnProperty("scheduleArr")
    //       ? m.scheduleArr.filter(
    //         (d: any) => (
    //           (d.startDate = d.ctstartDate),
    //            (d.endDate = d.ctendDate)
    //         )
    //       )
    //       : ""
    //   )
    //   : null;

    this.timezoneInfo
      ? this.tableobj.filter((m: any) =>
        m.hasOwnProperty("scheduleArr")
          ? m.scheduleArr.filter(
            (d: any) => (
              (d.startDate = (d.startDate)),
              (d.endDate = (d.endDate))
            )
          )
          : ""
      )
      : null;



    var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) => (

        (f.start = (

          new Date(f.NewStart).getFullYear() +
          "-" +
          (new Date(f.NewStart).getMonth() + 1) +
          "-" +
          new Date(f.NewStart).getDate()
        ).toString()),
        (f.createdDate = new Date(f.NewStart).toLocaleString()),
        (f.todayDate = new Date().toLocaleString()),
        (console.log(JSON.stringify(f)))
      )
    );

    console.log("occurance ------->>>>>>", this.tableobj);

    var unique = [...new Set(this.tableobj.map((a: any) => a.start))];
    console.log("unique------", unique);
    

    this.tableobj.length !== unique.length
      ? ((this.isLoadingIcon = false),
        (count = count + 1),
        (this.isFailure = true),
        (this.failureMessage = "Job(s) creating date can not be duplicate"))
      : "";

    


    //   this.tableobj.map((f: any) =>
    //   new Date(f.createdDate).getTime() < new Date(f.todayDate).getTime()
    //     ? ((this.isLoadingIcon = false),
    //       (count = count + 1),
    //       (this.isFailure = true),
    //       (this.failureMessage =
    //         "Job(s) creating date should be greater than current date & time"))
    //     : ""
    // );

    count === 0
      ? this._restService
        .saveJobSchedule(
          this.nrjEnvironment,
          this.nrjdescription,
          this.isRunNowSelected ? 0 : this.startType,
          this.estHoursSelection,
          this.estMinuteSelection,
          this.occurance,
          this.masterEnvId
        )
        .pipe(
          catchError((e) => {
            (this.isLoadingIcon = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            console.log("Save Job Schedule", f),
            (this.isSuccess = true),
            ((this.successMessage = f.response),
              (this.isLoadingIcon = false)),
            this.child.refreshScheduleTab(),
            this.closeJobModelShown()
          )
        )
      : "";
  }

  rs4Event() {
    this.isLoadingIcon = true;
    var occ = [];
    var count = 0;

    var t = this.tableobj.filter((m: any) =>
      m.hasOwnProperty("scheduleArr")
        ? m.scheduleArr.filter((d: any) =>
          d.IsNew === true
            ? ((d.Status = m.Status), (d.flagged = m.flagged))
            : ""
        )
        : ""
    );

    this.tableobj.filter((m: any, index: any) =>
      index === 0
        ? m.machineId === null || m.machineId === undefined
          ? (this.machineId = m.MachineId)
          : (this.machineId = m.machineId)
        : ""
    );

    console.log("machineId ------------->>>", this.machineId);
    console.log("Mid 1 ------------->>>", this.tableobj);

    this.tableobj.filter((m: any) =>
      m.hasOwnProperty("scheduleArr")
        ? m.scheduleArr.filter((d: any) =>
          d.IsNew === true ? occ.push(d) : ""
        )
        : ""
    );

    this.occurance = occ;
    var startDate = "";
    var endDate = "";

    console.log("Mid 2 ------------->>>", this.occurance);

    this.occurance.filter((f: any, i: any) =>
      i === 0
        ? ((startDate = f.startDate), console.log("s---------->", f.startDate))
        : ""
    );

    this.occurance.filter((f: any, i: any) =>
      i === this.occurance.length - 1
        ? ((endDate = f.endDate), console.log("s---------->", f.endDate))
        : ""
    );

    console.log("occurance", occ);
    this.isLoadingIcon = false;

    var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) => (
        (f.start = (
          new Date(f.NewStart).getFullYear() +
          "-" +
          (new Date(f.NewStart).getMonth() + 1) +
          "-" +
          new Date(f.NewStart).getDate()
        ).toString()),
        (f.createdDate = new Date(f.NewStart).toLocaleString()),
        (f.todayDate = new Date().toLocaleString())
      )
    );

    var unique = [...new Set(this.tableobj.map((a: any) => a.start))];

    this.tableobj.length !== unique.length
      ? ((this.isLoadingIcon = false),
        (count = count + 1),
        (this.isFailure = true),
        (this.failureMessage = "Job(s) creating date can not be duplicate"))
      : "";

    this.timezoneInfo
      ? this.tableobj.filter((m: any) =>
        m.hasOwnProperty("scheduleArr")
          ? m.scheduleArr.filter(
            (d: any) => (
              (d.startDate = d.startDate), (d.endDate = d.endDate)
            )
          )
          : ""
      )
      : null;

    // this.tableobj.map((f: any) =>
    //   new Date(f.createdDate).getTime() < new Date(f.todayDate).getTime()
    //     ? ((this.isLoadingIcon = false),
    //       (count = count + 1),
    //       (this.isFailure = true),
    //       (this.failureMessage =
    //         "Job(s) creating date should be greater than current date & time"))
    //     : ""
    // );

    count === 0
      ? this._restService
        .saveRecJobSchedule(
          this.nrjEnvironment,
          this.nrjjob,
          this.rjseries,
          this.nrjdescription,
          this.rjRepeatType,
          this.estHoursSelection,
          this.estMinuteSelection,
          this.saveFrequency,
          this.machineId,
          startDate,
          endDate,
          this.occurance,
          this.masterEnvId
        )
        .pipe(
          catchError((e) => {
            (this.isLoadingIcon = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            console.log("Save Job Schedule", f),
            (this.isSuccess = true),
            ((this.successMessage = f.response),
              (this.isLoadingIcon = false),
              this.child.refreshScheduleTab(),
              this.closeJobModelShown())
          )
        )
      : "";
  }

  chartExpandEvent(id: any,tbl:any) {
    console.log("tble---", tbl)
    this.isReviewDateShown = false;
    this.isReviewTimeShown = false;
    var col = this.tableobj;
    this.expandRowId = id;

    // col.filter(
    //   (f: any) => (
    //     (f.isfold = false),
    //     parseInt(f.rowid) === parseInt(id)
    //       ? f.isfold === true
    //         ? ((f.isfold = false), console.log("in", f.isfold))
    //         : ((f.isfold = true), console.log("out", f.isfold))
    //       : ""
    //   )
    // );

    col.filter((f: any) =>
      parseInt(f.rowid) === parseInt(id)
        ? f.isfold === false
          ? (f.isfold = true)
          : (f.isfold = false)
        : (f.isfold = false)
    );

    console.log("col", col);
    this.tableobj = col;

    console.log("Ckeck 1", this.tableobj);
    console.log("Ckeck 2", this.isRecurringSelected);
    console.log("Ckeck 3", this.machineId);

    var t = this.tableobj;
    t.filter((f: any) =>
      f.rowid === id
        ? (this.isRecurringSelected
          ? (this.editMachineId = this.machineId)
          : (this.editMachineId = f.machineId),
          (this.startDate = f.NewStart),
          localStorage.setItem(
            "cancelDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          ),
          localStorage.setItem(
            "singleDate",
            (
              new Date(f.NewStart).getDate() +
              "/" +
              (new Date(f.NewStart).getMonth() + 1) +
              "/" +
              new Date(f.NewStart).getFullYear()
            ).toString()
          )
          )
        : ""
    );

    // t.filter((f: any) =>
    //   f.rowid === id
    //     ? (new Date(f.NewStart).getHours() > 12
    //         ? new Date(f.NewStart).getHours() - 12 < 10
    //           ? (this.tphours = "0" + (new Date(f.NewStart).getHours() - 12))
    //           : (this.tphours = new Date(f.NewStart).getHours() - 12)
    //         : new Date(f.NewStart).getHours() < 10
    //         ? (this.tphours = "0" + new Date(f.NewStart).getHours())
    //         : new Date(f.NewStart).getHours(),
    //       (this.tpminutes =
    //         new Date(f.NewStart).getMinutes().toString().length <= 1
    //           ? "0" + new Date(f.NewStart).getMinutes()
    //           : new Date(f.NewStart).getMinutes()),
    //       (this.tptype = new Date(f.NewStart).getHours() > 12 ? "PM" : "AM"))
    //     : ""
    // );

    t.filter((f: any) =>
      f.rowid === id
        ? (new Date(f.NewStart).getHours() > 12
          ? (new Date(f.NewStart).getHours() - 12).toString().length > 1
            ? (this.tphours = new Date(f.NewStart).getHours() - 12)
            : (this.tphours = "0" + (new Date(f.NewStart).getHours() - 12))
          : new Date(f.NewStart).getHours() === 12
            ? (this.tphours = new Date(f.NewStart).getHours())
            : new Date(f.NewStart).getHours() < 12
              ? new Date(f.NewStart).getHours().toString().length > 1
                ? (this.tphours = new Date(f.NewStart).getHours())
                : (this.tphours = "0" + new Date(f.NewStart).getHours())
              : "",
          (this.tpminutes =
            new Date(f.NewStart).getMinutes().toString().length <= 1
              ? "0" + new Date(f.NewStart).getMinutes()
              : new Date(f.NewStart).getMinutes()),
          new Date(f.NewStart).getHours() >= 12
            ? (this.tptype = "PM")
            : new Date(f.NewStart).getHours() < 12
              ? (this.tptype = "AM")
              : "")
        : ""
    );

    t.filter((f: any) =>
      f.rowid === id
        ? (new Date(f.startDateBefore).getHours() > 12
          ? (new Date(f.startDateBefore).getHours() - 12).toString().length > 1
            ? (this.tshours = new Date(f.startDateBefore).getHours() - 12)
            : (this.tshours = "0" + (new Date(f.startDateBefore).getHours() - 12))
          : new Date(f.startDateBefore).getHours() === 12
            ? (this.tshours = new Date(f.startDateBefore).getHours())
            : new Date(f.startDateBefore).getHours() < 12
              ? new Date(f.startDateBefore).getHours().toString().length > 1
                ? (this.tshours = new Date(f.startDateBefore).getHours())
                : (this.tshours = "0" + new Date(f.startDateBefore).getHours())
              : "",
          (this.tpminutes =
            new Date(f.NewStart).getMinutes().toString().length <= 1
              ? "0" + new Date(f.NewStart).getMinutes()
              : new Date(f.NewStart).getMinutes()),
          new Date(f.NewStart).getHours() >= 12
            ? (this.tptype = "PM")
            : new Date(f.NewStart).getHours() < 12
              ? (this.tptype = "AM")
              : "")
        : ""
    );

    console.log("header----", this.headerobj)

    let duration = [];
    this.headerobj.hasOwnProperty("duration")
      ? (duration = this.headerobj.duration.split(":"))
      : "";

    console.log("tshours --->", this.tshours);

    this.headerobj.hasOwnProperty("jobDuration")
      ? (this.estEditHoursSelection = this.headerobj.jobDuration.hours)
      : (this.estEditHoursSelection = parseInt(duration[0]));

    this.headerobj.hasOwnProperty("jobDuration")
      ? (this.estEditMinuteSelection = this.headerobj.jobDuration.minutes)
      : (this.estEditMinuteSelection = parseInt(duration[1]));

    console.log("duration --->", this.estEditHoursSelection);

  }

  reviewDateEvent() {
    this.isReviewDateShown = !this.isReviewDateShown;
    this.isReviewTimeShown = false;
  }

  closeDate() {
    var d = localStorage.getItem("cancelDate");
    this.startDate = d.split("/").reverse().join("-");
    localStorage.setItem("singleDate", d);
    localStorage.setItem('mSingleDate',d);
    this.isReviewDateShown = false;
  }

  applyDate() {
    
    var d = localStorage.getItem("singleDate");
    this.startDate = d.split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) => (
        console.log(f.NewStart + "---" + this.startDate + "---" + d),
        (f.start = (
          new Date(f.NewStart).getFullYear() +
          "-" +
          (new Date(f.NewStart).getMonth() + 1) +
          "-" +
          new Date(f.NewStart).getDate()
        ).toString())
      )
    );

    this.tableobj.map((f: any) =>
      f.rowid !== this.expandRowId
        ? f.start === this.startDate
          ? ((this.isFailure = true),
            (this.failureMessage = "Selected date is already exists"))
          : ""
        : ""
    );

    console.log("Dates -->", this.tableobj);

    localStorage.setItem("singleDate", d);
    localStorage.setItem("cancelDate", d);
    localStorage.setItem("mSingleDate", d);
    this.isRangeStartShown = false;
    this.isReviewDateShown = false;
  }

  applyRangeStartDate() {
    var d = localStorage.getItem("startRange");
    this.rangestart = d.split("/").reverse().join("-");
    localStorage.setItem("startRange", d);
    this.isRangeStartShown = false;
  }

  applyRangeEndDate() {
    var d = localStorage.getItem("endRange");
    var ed = d.split("/").reverse().join("-");

    if (new Date(ed) > new Date(this.rangestart)) {
      this.rangeend = ed;
      localStorage.setItem("endRange", d);
      this.isRangeEndShown = false;
    } else {
      this.isFailure = true;
      this.failureMessage = "End date should be greater than start date";
    }
  }

  closeRangeStartDate() {
    this.isRangeStartShown = false;
  }

  closeRangeEndDate() {
    this.isRangeEndShown = false;
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
    this.isJobModelShown = false;
    this.isMaintenanceModelShown = false;
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  reviewTimeEvent(id: any) {
    this.isReviewTimeShown = !this.isReviewTimeShown;
    this.isReviewDateShown = false;
  }

  changetimeformat() {
    var f = this.tptype;
    f === "AM" ? (this.tptype = "PM") : (this.tptype = "AM");
  }

  closeTime() {
    this.isReviewTimeShown = false;
  }

  increaseHrs() {
    var hrs = parseInt(this.tphours) + 1;
    this.disableDecreaseHrs = false;
    if (hrs >= 12) {
      this.tphours = 12;
      this.disableIncreaseHrs = true;
    } else {
      this.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableIncreaseHrs = false;
    }
  }

  decreaseHrs() {
    var hrs = parseInt(this.tphours) - 1;
    this.disableIncreaseHrs = false;
    if (hrs <= 0) {
      this.tphours = "00";
      this.disableDecreaseHrs = true;
    } else {
      this.tphours = hrs >= 10 ? hrs : "0" + hrs;
      this.disableDecreaseHrs = false;
    }
  }

  increaseMins() {
    var mins = parseInt(this.tpminutes) + 1;
    this.disableDecreaseMins = false;
    if (mins > 59) {
      this.disableIncreaseMins = true;
    } else {
      this.disableIncreaseMins = false;
      this.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  decreaseMins() {
    var mins = parseInt(this.tpminutes);
    this.disableIncreaseMins = false;
    if (mins === 0) {
      this.disableDecreaseMins = true;
      this.tpminutes = "00";
    } else {
      mins = parseInt(this.tpminutes) - 1;
      this.disableDecreaseMins = false;
      this.tpminutes = mins >= 10 ? mins : "0" + mins;
    }
  }

  updateSchedule(id: any) {
    this.isLoadingIcon = true;
    this.isDifferentTimezone = true;
    var count = 0;
    console.log("startDatessss", this.startDate);
    console.log("tphours", this.tphours);
    console.log("tpminutes", this.tpminutes);
    console.log("tptype", this.tptype);
    console.log("estEditHoursSelection", this.estHoursSelection);
    console.log("estEditMinuteSelection", this.estEditMinuteSelection);
    console.log("editMachineId", this.editMachineId);
    console.log("MachineId", this.machineId);

    var ty = this.tptype === "AM" ? this.tphours : parseInt(this.tphours) + 12;

    var t = this.tableobj;

    // var sd = (
    //   new Date(this.startDate).getFullYear() +
    //   "-" +
    //   (new Date(this.startDate).getMonth() + 1) +
    //   "-" +
    //   new Date(this.startDate).getDate() +
    //   " " +
    //   ty +
    //   ":" +
    //   this.tpminutes +
    //   ":" +
    //   "00"
    // ).toString();

    // this.editedStartDateArray.push(sd);


    t.filter((f: any) =>
      f.rowid === id
        ? (f.NewStart = (
          new Date(this.startDate).getFullYear() +
          "-" +
          (new Date(this.startDate).getMonth() + 1) +
          "-" +
          new Date(this.startDate).getDate() +
          " " +
          ty +
          ":" +
          this.tpminutes +
          ":" +
          "00"
        ).toString())
        : ""
    );

    var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) =>
      (f.start = (
        new Date(f.NewStart).getFullYear() +
        "-" +
        (new Date(f.NewStart).getMonth() + 1) +
        "-" +
        new Date(f.NewStart).getDate()
      ).toString())
    );

    this.tableobj.map((f: any) =>
      f.rowid !== this.expandRowId
        ? f.start === d
          ? ((this.isLoadingIcon = false),
            (count = count + 1),
            (this.isFailure = true),
            (this.failureMessage = "Selected date is already exists"))
          : ""
        : ""
    );


    this.tableobj = t;
    this.editedStartDateArray = [];
    this.tableobj;
    // this.editedStartDateArray.push((this.startDate));
    // this.estHoursSelection = this.estEditHoursSelection;
    console.log("est--->" , this.estHoursSelection);
    

    t.filter((f: any) => this.editedStartDateArray.push(this.timezoneConvert(f.NewStart)));
    console.log("tttttt---->", t);


    count === 0
      ? this.estEditHoursSelection === "0" &&
        this.estEditMinuteSelection === "0"
        ? ((this.isLoadingIcon = false),
          (this.isFailure = true),
          (this.failureMessage = "Estimated duration time is required"))
        : this._restService
          .createJobSchedule(
            this.nrjEnvironment,
            this.nrjjob,
            this.nrjdescription,
            3,
            this.editedStartDateArray,
            this.editMachineId,
            this.estEditHoursSelection,
            this.estEditMinuteSelection,
            false,
            false,
            0,
            this.masterEnvId
          )
          .pipe(
            catchError((e) => {
              (this.isLoadingIcon = false),
                (this.isFailure = true),
                (this.failureMessage = e.error.response
                  ? e.error.response
                  : e.error.StatusInfo);
              return e;
            })
          )
          .subscribe(
            (f: any) => (
              console.log("createJobSchedule", f.scheduleListRes),
              (this.tableobj = []),
              (this.headerobj = f.scheduleListRes.Header),
              (this.machineobj = f.scheduleListRes.machineList),
              (this.tableobj = f.scheduleListRes.OccuranceTable),
              this.tableobj.filter((m: any) => (m.isfold = false)),
              this.tableobj.filter(
                (m: any, index: any) => (m.rowid = index + 1)
              ),
              this.tableobj.filter(
                (m: any, index: any) => (
                  (m.startDateBefore = (m.NewStart)),
                  (m.endDateBefore = (m.NewEnd)),
                  (m.NewStart = this.timezoneConvert(m.NewStart)),
                  (m.NewEnd = this.timezoneConvert(m.NewEnd)),

                  console.log("end 12", JSON.stringify(m.startDateBefore))
                ),
              ),
              console.log("table 1", this.tableobj),
              this.tableobj.filter((m: any) =>
                SchedulerUtils.updateScheduleObject(m)
              ),
              console.log("table 2", this.tableobj),
              (this.isLoadingIcon = false)
            )
          )
      : "";
  }

  updateMaintenanceSingle(e: any,tbl:any) {
    console.log("entry 1");
    console.log("converted---->", tbl)

    this.isLoadingIcon = true;
    var hm = [];
    var count = 0;
    console.log("log", this.tableobj);
    
    var shour =
      this.tptype === "AM" ? this.tphours : parseInt(this.tphours) + 12;
      // var timeZoneFromDB: any = localStorage.getItem('timezoneName');

    var t: any;
    var sd: any;
    var sdt: any;

    var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) =>
      (f.start = (
        new Date(f.NewStart).getFullYear() +
        "-" +
        (new Date(f.NewStart).getMonth() + 1) +
        "-" +
        new Date(f.NewStart).getDate()
      ).toString())
    );
    var dm = localStorage.getItem("mSingleDate").split("/").reverse().join("-");
   
    var ds = localStorage.getItem("selectedDates").split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) =>
      (f.start = (
        new Date(f.NewStart).getFullYear() +
        "-" +
        (new Date(f.NewStart).getMonth() + 1) +
        "-" +
        new Date(f.NewStart).getDate()
      ).toString())
    );


    var dates = d + ' ' + this.tphours + ':' + this.tpminutes + ':' + '00';
    dates = this.timezoneConvert(dates);

    var hour = new Date(dates).getHours().toString().padStart(2, "0");
    var minute = new Date(dates).getMinutes().toString().padStart(2, "0")

    var range = {
      startTime: {
        hours: hour.toString(),
        minutes: minute.toString(),
      },
      end: {
        endTime: {
          hours: "00",
          minutes: "00",
          totalDuration: "00",
        },
        duration: {
          hours: this.estEditHoursSelection.toString(),
          minutes: this.estEditMinuteSelection.toString(),
        },
        isEndTime: false,
      },
    };
    

    //this.tableobj.map((f: any) => alert(f.rowid + "--" + this.expandRowId));

    this.tableobj.map((f: any) =>
      f.rowid !== this.expandRowId
        ? f.start === d
          ? ((this.isLoadingIcon = false),
            (count = count + 1),
            (this.isFailure = true),
            (this.failureMessage = "Selected date is already exists"))
          : ((t = localStorage.getItem("singleDate")),
            (sd = localStorage.getItem("selectedDates").split(",")),
            console.log("SDT", sd),
            sd.map((f: any, i: any) =>
              i + 1 === this.expandRowId ? (sd[i] = t) : ""
            ),
            (sdt = sd.map((m: any) => (m = m.split("/").reverse().join("-")))),
            localStorage.setItem("selectedDates", sd.toString()))
        : ((sd = localStorage.getItem("selectedDates").split(",")),
          (sdt = sd.map((m: any) => (m = m.split("/").reverse().join("-")))))
    );
    sdt = sdt.filter(function (el) {
      return el != "";
    });
    console.log("Selected Dates -------", sdt);
    console.log("tableobj", this.tableobj);
    console.log("d", d);
    console.log("d", dm);
    console.log("std", sdt);
    console.log("dates--->" + JSON.stringify(sdt));
    t = localStorage.getItem("singleDate");
    t = t.split("/").reverse().join("-");

    var sdateMtn = [];
    this.tableobj.length === 1 ? sdateMtn.push(dm) : "";
    var dts = this.tableobj.length === 1 ? sdateMtn : sdt;    

    count === 0
      ? this.estEditHoursSelection.toString() === "0" &&
        this.estEditMinuteSelection.toString() === "0"
        ? ((this.isLoadingIcon = false),
          (this.isFailure = true),
          (this.failureMessage = "Estimated duration time is required"))
        : this._restService
          .createMaintenanceSchedule(
            this.mSingle2Data.activityLabel,
            this.mSingle2Data.environment,
            this.mSingle2Data.systemAccess,
            this.mSingle2Data.description,
            dts,
            range,
            false,
            0,
            this.masterEnvId
          )
          .pipe(
            catchError((e) => {
              (this.isLoadingIcon = false),
                (this.isFailure = true),
                (this.failureMessage = e.error.response
                  ? e.error.response
                  : e.error.StatusInfo);
              return e;
            })
          )
          .subscribe(
            (f: any) => (
              console.log(f),
              (this.tableobj = []),
              (this.headerobj = f.maintenanceRes.headerObj),
              (this.tableobj = f.maintenanceRes.OccuranceTable),
              this.tableobj.filter((m: any) => (m.isfold = false)),
              this.tableobj.filter(
                (m: any, index: any) => (m.rowid = index + 1)
              ),
              this.headerobj.hasOwnProperty("duration")
                ? ((hm = this.headerobj.duration.split(":")),
                  (this.headerobj.hours = hm[0]),
                  (this.headerobj.mins = hm[1]))
                : "",
              this.tableobj.filter(
                (m: any, index: any) => (
                  (m.startDateBefore = (m.NewStart)),
                  (m.endDateBefore = (m.NewEnd)),
                  (m.NewStart = this.timezoneConvert(m.NewStart)),
                  (m.NewEnd = this.timezoneConvert(m.NewEnd)),
                  console.log("end 14", m.startDateBefore)
                ),
              ),
              this.tableobj.filter((m: any) =>
                SchedulerUtils.updateMaintenanceObject(m)
              ),
              console.log("table final1 ---->>>>>", this.tableobj),
              (this.isLoadingIcon = false)
            )
          )
      : "";
  }

  // updateMaintenanceSeries(rowId: any) {
  //   console.log("entry------");
  //   this.isLoadingIcon = true;
  //   var count = 0;
  //   var sd: any;
  //   var t: any;
  //   var sinledate = localStorage.getItem('singleDate');
  //   var s = sinledate.split("/").reverse().join("-");
  //   var ds = [];
  //   ds.push(s);
  //   console.log("dates--->" + JSON.stringify(ds));

  //   var dates = ds + ' ' + this.tphours + ':' + this.tpminutes + ':' + '00';
  //   dates = this.timezoneConvert(dates);

  //   var hour = new Date(dates).getHours().toString().padStart(2, "0");
  //   var minute = new Date(dates).getMinutes().toString().padStart(2, "0");

  //   var shour =
  //     this.tptype === "AM" ? this.tphours : parseInt(this.tphours) + 12;

  //   var range = {
  //     startTime: {
  //       hours: hour.toString(),
  //       minutes: minute.toString(),
  //     },
  //     end: {
  //       endTime: {
  //         hours: "00",
  //         minutes: "00",
  //         totalDuration: (
  //           this.estEditHoursSelection +
  //           ":" +
  //           this.estEditMinuteSelection
  //         ).toString(),
  //       },
  //       duration: {
  //         hours: this.estEditHoursSelection.toString(),
  //         minutes: this.estEditMinuteSelection.toString(),
  //       },
  //       isEndTime: false,
  //     },
  //   };

  //   var t: any;
  //   var sd: any;
  //   var sdt: any;

  //   var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
  //   this.tableobj.map(
  //     (f: any) =>
  //     (f.start = (
  //       new Date(f.NewStart).getFullYear() +
  //       "-" +
  //       (new Date(f.NewStart).getMonth() + 1) +
  //       "-" +
  //       new Date(f.NewStart).getDate()
  //     ).toString())
  //   );

  //   this.tableobj.map((f: any) =>
  //     f.rowid !== this.expandRowId
  //       ? f.start === d
  //         ? ((this.isLoadingIcon = false),
  //           (count = count + 1),
  //           (this.isFailure = true),
  //           (this.failureMessage = "Selected date is already exists"))
  //         : ((t = localStorage.getItem("singleDate")),
  //           (sd = localStorage.getItem("selectedDates").split(",")),
  //           sd.map((f: any, i: any) =>
  //             i + 1 === this.expandRowId ? (sd[i] = t) : ""
  //           ),
  //           (sdt = sd.map((m: any) => (m = m.split("/").reverse().join("-")))),
  //           localStorage.setItem("selectedDates", sd.toString()))
  //       : ""
  //   );
  //   sdt = sdt.filter(function (el) {
  //     return el != "";
  //   });
  //   console.log("rowId--->" + rowId);

  //   console.log("mSeries2Data --- Maari --", this.mSeries2Data);
  //   console.log("mSeries3Data ---Maari --", this.mSeries3Data);
  //   console.log("mSeriesStep2Data", this.mSeries2Data);

  //   count === 0
  //     ? this.estEditHoursSelection.toString() === "0" &&
  //       this.estEditMinuteSelection.toString() === "0"
  //       ? ((this.isLoadingIcon = false),
  //         (this.isFailure = true),
  //         (this.failureMessage = "Estimated duration time is required"))
  //       : this._restService
  //         .createMaintenanceSchedule(
  //           this.mSeries2Data.activityLabel,
  //           this.mSeries2Data.environment,
  //           this.mSeries2Data.systemAccess,
  //           this.mSeries2Data.description,
  //           sdt,
  //           range,
  //           false,
  //           0,
  //           rowId
  //         )
  //         .pipe(
  //           catchError((e) => {
  //             (this.isLoadingIcon = false),
  //               (this.isFailure = true),
  //               (this.failureMessage = e.error.response
  //                 ? e.error.response
  //                 : e.error.StatusInfo);
  //             return e;
  //           })
  //         )
  //         .subscribe(
  //           (f: any) => (
  //             console.log("f --->", f),
  //             console.log("Mseries Result", f.maintenanceRes.OccuranceTable),
  //             (this.tableobj = []),
  //             (this.headerobj = f.maintenanceRes.headerObj),
  //             (this.tableobj = f.maintenanceRes.OccuranceTable),
  //             this.tableobj.filter((m: any) => (m.isfold = false)),
  //             this.tableobj.filter(
  //               (m: any, index: any) => (m.rowid = index + 1)
  //             ),
  //             // this.tableobj.filter(
  //             //   (m: any, index: any) => (
  //             //     (m.startDateBefore = m.NewStart),
  //             //     (m.endDateBefore = m.NewEnd),
  //             //     (m.NewStart = this.timezoneConvert(m.NewStart)),
  //             //     (m.NewEnd = this.timezoneConvert(m.NewEnd)),
  //             //     console.log("end 15", m.startDateBefore)
  //             //   ),
  //             // ),
  //             console.log("table 1", this.tableobj),
  //             this.tableobj.filter((m: any) =>
  //               m.hasOwnProperty("MaintenaceAccess")
  //                 ? m.MaintenaceAccess.filter(
  //                   (a: any) => (
  //                     a.hasOwnProperty("Mlist")
  //                       ? a.Mlist.filter((dt: any) =>
  //                         this.addingHoursMinutes(dt)
  //                       )
  //                       : "",
  //                     a.hasOwnProperty("children")
  //                       ? a.children.filter(
  //                         (b: any) => (
  //                           b.hasOwnProperty("Mlist")
  //                             ? b.Mlist.filter((dt: any) =>
  //                               this.addingHoursMinutes(dt)
  //                             )
  //                             : "",
  //                           b.hasOwnProperty("children")
  //                             ? b.children.filter(
  //                               (c: any) => (
  //                                 c.hasOwnProperty("Mlist")
  //                                   ? c.Mlist.filter((dt: any) =>
  //                                     this.addingHoursMinutes(dt)
  //                                   )
  //                                   : "",
  //                                 c.hasOwnProperty("children")
  //                                   ? c.children.filter(
  //                                     (d: any) => (
  //                                       d.hasOwnProperty("Mlist")
  //                                         ? d.Mlist.filter(
  //                                           (dt: any) =>
  //                                             this.addingHoursMinutes(
  //                                               dt
  //                                             )
  //                                         )
  //                                         : "",
  //                                       d.hasOwnProperty("children")
  //                                         ? d.children.filter(
  //                                           (f: any) => (
  //                                             f.hasOwnProperty(
  //                                               "Mlist"
  //                                             )
  //                                               ? f.Mlist.filter(
  //                                                 (dt: any) =>
  //                                                   this.addingHoursMinutes(
  //                                                     dt
  //                                                   )
  //                                               )
  //                                               : "",
  //                                             f.hasOwnProperty(
  //                                               "children"
  //                                             )
  //                                               ? f.children.filter(
  //                                                 (g: any) => (
  //                                                   g.hasOwnProperty(
  //                                                     "Mlist"
  //                                                   )
  //                                                     ? g.Mlist.filter(
  //                                                       (
  //                                                         dt: any
  //                                                       ) =>
  //                                                         this.addingHoursMinutes(
  //                                                           dt
  //                                                         )
  //                                                     )
  //                                                     : "",
  //                                                   g.hasOwnProperty(
  //                                                     "children"
  //                                                   )
  //                                                     ? g.children.filter(
  //                                                       (
  //                                                         h: any
  //                                                       ) => (
  //                                                         h.hasOwnProperty(
  //                                                           "Mlist"
  //                                                         )
  //                                                           ? h.Mlist.filter(
  //                                                             (
  //                                                               dt: any
  //                                                             ) =>
  //                                                               this.addingHoursMinutes(
  //                                                                 dt
  //                                                               )
  //                                                           )
  //                                                           : "",
  //                                                         h.hasOwnProperty(
  //                                                           "children"
  //                                                         )
  //                                                           ? h.children.filter(
  //                                                             (
  //                                                               j: any
  //                                                             ) => (
  //                                                               j.hasOwnProperty(
  //                                                                 "Mlist"
  //                                                               )
  //                                                                 ? j.Mlist.filter(
  //                                                                   (
  //                                                                     dt: any
  //                                                                   ) =>
  //                                                                     this.addingHoursMinutes(
  //                                                                       dt
  //                                                                     )
  //                                                                 )
  //                                                                 : "",
  //                                                               j.hasOwnProperty(
  //                                                                 "children"
  //                                                               )
  //                                                                 ? j.children.filter(
  //                                                                   (
  //                                                                     k: any
  //                                                                   ) => (
  //                                                                     k.hasOwnProperty(
  //                                                                       "Mlist"
  //                                                                     )
  //                                                                       ? k.Mlist.filter(
  //                                                                         (
  //                                                                           dt: any
  //                                                                         ) =>
  //                                                                           this.addingHoursMinutes(
  //                                                                             dt
  //                                                                           )
  //                                                                       )
  //                                                                       : "",
  //                                                                     k.hasOwnProperty(
  //                                                                       "children"
  //                                                                     )
  //                                                                       ? k.children.filter(
  //                                                                         (
  //                                                                           l: any
  //                                                                         ) => (
  //                                                                           l.hasOwnProperty(
  //                                                                             "Mlist"
  //                                                                           )
  //                                                                             ? l.Mlist.filter(
  //                                                                               (
  //                                                                                 dt: any
  //                                                                               ) =>
  //                                                                                 this.addingHoursMinutes(
  //                                                                                   dt
  //                                                                                 )
  //                                                                             )
  //                                                                             : "",
  //                                                                           l.hasOwnProperty(
  //                                                                             "children"
  //                                                                           )
  //                                                                             ? l.children.filter(
  //                                                                               (
  //                                                                                 m: any
  //                                                                               ) =>
  //                                                                                 m.hasOwnProperty(
  //                                                                                   "Mlist"
  //                                                                                 )
  //                                                                                   ? m.Mlist.filter(
  //                                                                                     (
  //                                                                                       dt: any
  //                                                                                     ) =>
  //                                                                                       this.addingHoursMinutes(
  //                                                                                         dt
  //                                                                                       )
  //                                                                                   )
  //                                                                                   : ""
  //                                                                             )
  //                                                                             : ""
  //                                                                         )
  //                                                                       )
  //                                                                       : ""
  //                                                                   )
  //                                                                 )
  //                                                                 : ""
  //                                                             )
  //                                                           )
  //                                                           : ""
  //                                                       )
  //                                                     )
  //                                                     : ""
  //                                                 )
  //                                               )
  //                                               : ""
  //                                           )
  //                                         )
  //                                         : ""
  //                                     )
  //                                   )
  //                                   : ""
  //                               )
  //                             )
  //                             : ""
  //                         )
  //                       )
  //                       : ""
  //                   )
  //                 )
  //                 : ""
  //             ),
  //             console.log("table final2 ---->>>>>", this.tableobj),
  //             (this.isLoadingIcon = false)
  //           )
  //         )
  //     : "";
  // }

  updateMaintenanceSeries(tbl:any) {
    console.log("tbl----" , tbl);
    var occid;
    console.log("occid----" + occid);
    
    // this.occID = occid;
    this.isLoadingIcon = true;
    var shour =
      this.tptype === "AM" ? this.tphours : parseInt(this.tphours) + 12;

      var sds = new Date(this.startDate).toLocaleDateString("fr-CA");
      var sm = sds.split("/").reverse().join("-");
      // var sdt = [];
      // sdt.push(s);

      var dates = sm + ' ' + this.tphours + ':' + this.tpminutes + ':' + '00';
      dates = this.timezoneConvert(dates);
  
      var hour = new Date(dates).getHours().toString().padStart(2, "0");
      var minute = new Date(dates).getMinutes().toString().padStart(2, "0")
  
      var range = {
        startTime: {
          hours: hour.toString(),
          minutes: minute.toString(),
        },
        end: {
          endTime: {
            hours: "00",
            minutes: "00",
            totalDuration: "00",
          },
          duration: {
            hours: this.estEditHoursSelection.toString(),
            minutes: this.estEditMinuteSelection.toString(),
          },
          isEndTime: false,
        },
      };

    // var range = {
    //   startTime: {
    //     hours: shour.toString(),
    //     minutes: this.tpminutes.toString(),
    //   },
    //   end: {
    //     endTime: {
    //       hours: "00",
    //       minutes: "00",
    //       totalDuration: "00",
    //     },
    //     duration: {
    //       hours: this.estEditHoursSelection.toString(),
    //       minutes: this.estEditMinuteSelection.toString(),
    //     },
    //     isEndTime: false,
    //   },
    // };

    var sd = new Date(this.startDate).toLocaleDateString("fr-CA");
    var s = sd.split("/").reverse().join("-");
    var sdt = [];
    sdt.push(s);
    console.log("dates--->" + JSON.stringify(sdt));


    this._restService
      .createMaintenanceSchedule(
                 this.mSeries2Data.activityLabel,
                  this.mSeries2Data.environment,
                  this.mSeries2Data.systemAccess,
                  this.mSeries2Data.description,
                  sdt,
                  range,
                  false,
                  this.expandRowId,
                this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log("1", f),
          console.log("3", this.mtnRecurringRes),
          console.log("4", occid),
          //response.headerObj
         
          this.mtnRecurringRes.RecurringRes.OccuranceTable.filter(
            (m: any, i: any) =>
              parseInt(m.rowid) === parseInt(this.expandRowId)
                ? Object.assign(m, f.maintenanceRes.OccuranceTable[0])
                : ""
          ),
          console.log("1---",this.mtnRecurringRes.RecurringRes.OccuranceTable),
          console.log("2", this.mtnRecurringRes),

          this.mtnRecurringRes.RecurringRes.OccuranceTable.filter(
            (m: any, i: any) =>
              parseInt(m.rowid) === parseInt(this.expandRowId)
                ? (m.isEdited = true)
                : ""
          ),
          (this.tableobj = []),
          (this.headerobj = this.mtnRecurringRes.RecurringRes.headerObj),
          (this.tableobj = this.mtnRecurringRes.RecurringRes.OccuranceTable),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          // (this.tableobj = []),
          // (this.headerobj = this.mtnRecurringRes.response.headerObj),
          // (this.tableobj = this.mtnRecurringRes.response.OccuranceTable),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.endTime = new Date(m.NewEnd).getTime()),
              (m.startTime = new Date(m.NewStart).getTime())
            )
          ),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.seconds = (m.endTime - m.startTime) / 1000),
              (m.duration =
                Math.floor(m.seconds / 3600) +
                ":" +
                (Math.floor(m.seconds / 60) % 60))
            )
          ),

          f.maintenanceRes.OccuranceTable.filter((m:any) => (
            console.log("data...." ,(f.maintenanceRes.OccuranceTable[0])),
            m.sstartbefore = f.maintenanceRes.OccuranceTable[0].NewStart,
            m.sendbefore = f.maintenanceRes.OccuranceTable[0].NewEnd,
            m.sstart = this.timezoneConvert(f.maintenanceRes.OccuranceTable[0].NewStart),
            m.send = this.timezoneConvert(f.maintenanceRes.OccuranceTable[0].NewEnd),
            m.rowid = this.expandRowId,

           this.tableobj.filter(function (item) {

                  if(item.rowid === m.rowid) {
                    
                  console.log("m---", (item.NewStart)),
                  (item.startDateBefore = m.sstartbefore),
                  (item.endDateBefore = m.sendbefore),
                  (item.NewStart = m.sstart),
                  (item.NewEnd = m.send)
                  } 
                })            
          )
          ),

          // this.tableobj.filter(
          //   (m: any, index: any) => (
          //     (m.startDateBefore =(m.NewStart)),
          //     (m.endDateBefore = (m.NewEnd)),
          //     (m.NewStart = this.timezoneConvert(m.NewStart)),
          //     (m.NewEnd = this.timezoneConvert(m.NewEnd)),
          //     console.log("end 12", JSON.stringify(m.startDateBefore))
          //   ),
          // ),
          console.log("table 1", this.tableobj),
          console.log("table final ---->>>>>", this.tableobj),
          this.tableobj.filter((m: any) => SchedulerUtils.updateMaintenanceObject(m) ),
          // this.tableobj.filter((m: any) =>
          //   m.hasOwnProperty("MaintenaceAccess")
          //     ? m.MaintenaceAccess.filter(
          //       (a: any) => (
          //         a.hasOwnProperty("Mlist")
          //           ? a.Mlist.filter((dt: any) => this.addingHoursMinutes(dt))
          //           : "",
          //         a.hasOwnProperty("children")
          //           ? a.children.filter(
          //             (b: any) => (
          //               b.hasOwnProperty("Mlist")
          //                 ? b.Mlist.filter((dt: any) =>
          //                   this.addingHoursMinutes(dt)
          //                 )
          //                 : "",
          //               b.hasOwnProperty("children")
          //                 ? b.children.filter(
          //                   (c: any) => (
          //                     c.hasOwnProperty("Mlist")
          //                       ? c.Mlist.filter((dt: any) =>
          //                         this.addingHoursMinutes(dt)
          //                       )
          //                       : "",
          //                     c.hasOwnProperty("children")
          //                       ? c.children.filter(
          //                         (d: any) => (
          //                           d.hasOwnProperty("Mlist")
          //                             ? d.Mlist.filter((dt: any) =>
          //                               this.addingHoursMinutes(dt)
          //                             )
          //                             : "",
          //                           d.hasOwnProperty("children")
          //                             ? d.children.filter(
          //                               (f: any) => (
          //                                 f.hasOwnProperty("Mlist")
          //                                   ? f.Mlist.filter(
          //                                     (dt: any) =>
          //                                       this.addingHoursMinutes(
          //                                         dt
          //                                       )
          //                                   )
          //                                   : "",
          //                                 f.hasOwnProperty("children")
          //                                   ? f.children.filter(
          //                                     (g: any) => (
          //                                       g.hasOwnProperty(
          //                                         "Mlist"
          //                                       )
          //                                         ? g.Mlist.filter(
          //                                           (dt: any) =>
          //                                             this.addingHoursMinutes(
          //                                               dt
          //                                             )
          //                                         )
          //                                         : "",
          //                                       g.hasOwnProperty(
          //                                         "children"
          //                                       )
          //                                         ? g.children.filter(
          //                                           (h: any) => (
          //                                             h.hasOwnProperty(
          //                                               "Mlist"
          //                                             )
          //                                               ? h.Mlist.filter(
          //                                                 (
          //                                                   dt: any
          //                                                 ) =>
          //                                                   this.addingHoursMinutes(
          //                                                     dt
          //                                                   )
          //                                               )
          //                                               : "",
          //                                             h.hasOwnProperty(
          //                                               "children"
          //                                             )
          //                                               ? h.children.filter(
          //                                                 (
          //                                                   j: any
          //                                                 ) => (
          //                                                   j.hasOwnProperty(
          //                                                     "Mlist"
          //                                                   )
          //                                                     ? j.Mlist.filter(
          //                                                       (
          //                                                         dt: any
          //                                                       ) =>
          //                                                         this.addingHoursMinutes(
          //                                                           dt
          //                                                         )
          //                                                     )
          //                                                     : "",
          //                                                   j.hasOwnProperty(
          //                                                     "children"
          //                                                   )
          //                                                     ? j.children.filter(
          //                                                       (
          //                                                         k: any
          //                                                       ) => (
          //                                                         k.hasOwnProperty(
          //                                                           "Mlist"
          //                                                         )
          //                                                           ? k.Mlist.filter(
          //                                                             (
          //                                                               dt: any
          //                                                             ) =>
          //                                                               this.addingHoursMinutes(
          //                                                                 dt
          //                                                               )
          //                                                           )
          //                                                           : "",
          //                                                         k.hasOwnProperty(
          //                                                           "children"
          //                                                         )
          //                                                           ? k.children.filter(
          //                                                             (
          //                                                               l: any
          //                                                             ) => (
          //                                                               l.hasOwnProperty(
          //                                                                 "Mlist"
          //                                                               )
          //                                                                 ? l.Mlist.filter(
          //                                                                   (
          //                                                                     dt: any
          //                                                                   ) =>
          //                                                                     this.addingHoursMinutes(
          //                                                                       dt
          //                                                                     )
          //                                                                 )
          //                                                                 : "",
          //                                                               l.hasOwnProperty(
          //                                                                 "children"
          //                                                               )
          //                                                                 ? l.children.filter(
          //                                                                   (
          //                                                                     m: any
          //                                                                   ) =>
          //                                                                     m.hasOwnProperty(
          //                                                                       "Mlist"
          //                                                                     )
          //                                                                       ? m.Mlist.filter(
          //                                                                         (
          //                                                                           dt: any
          //                                                                         ) =>
          //                                                                           this.addingHoursMinutes(
          //                                                                             dt
          //                                                                           )
          //                                                                       )
          //                                                                       : ""
          //                                                                 )
          //                                                                 : ""
          //                                                             )
          //                                                           )
          //                                                           : ""
          //                                                       )
          //                                                     )
          //                                                     : ""
          //                                                 )
          //                                               )
          //                                               : ""
          //                                           )
          //                                         )
          //                                         : ""
          //                                     )
          //                                   )
          //                                   : ""
          //                               )
          //                             )
          //                             : ""
          //                         )
          //                       )
          //                       : ""
          //                   )
          //                 )
          //                 : ""
          //             )
          //           )
          //           : ""
          //       )
          //     )
          //     : ""
          // ),
          (this.isLoadingIcon = false)
        )
      );
  }


  cancelSchedule(id: any) {
    var t = this.tableobj;
    t.filter((f: any) =>
      f.rowid === id
        ? f.isfold === true
          ? (f.isfold = false)
          : (f.isfold = true)
        : ""
    );
  }

  resetSchedule(id: any,tbl) {
    this.chartExpandEvent(id,tbl);
  }

  rjRepeatTypeEvent(e: any) {
    this.isDayOneSelected = true;
    this.isDayTwoSelected = false;
    this.isWeekOneSelected = true;
    this.isWeekTwoSelected = false;
    this.isMonthOneSelected = true;
    this.isMonthTwoSelected = false;
    this.isMonthOneSelected = true;
    this.isMonthTwoSelected = false;
    this.isMonthThreeSelected = false;
    (this.isWeekTwoMonSelected = true),
      (this.isWeekTwoTueSelected = false),
      (this.isWeekTwoWedSelected = false),
      (this.isWeekTwoThuSelected = false),
      (this.isWeekTwoFriSelected = false),
      (this.isWeekTwoSatSelected = false),
      (this.isWeekTwoSunSelected = false);
    (this.isMonthThreeOneSelected = true),
      (this.isMonthThreeSecSelected = false),
      (this.isMonthThreeThrSelected = false),
      (this.isMonthThreefourSelected = false),
      (this.isMonthThreelastSelected = false);

    this.monthofyear = "1";
    this.dayfrequency = "";
    this.weekfrequency = "";
    this.monthfrequency = "";
    this.yearfrequency = "";
    this.isdayfrequencyEmpty = false;
    this.isweekfrequencyEmpty = false;
    this.ismonthfrequencyEmpty = false;
    this.isyearfrequencyEmpty = false;

    e.target.value === 1
      ? ((this.isDayOneSelected = true), (this.isDayTwoSelected = false))
      : e.target.value === 2
        ? ((this.isWeekOneSelected = true), (this.isWeekTwoSelected = false))
        : e.target.value === 3
          ? ((this.isMonthOneSelected = true),
            ((this.isMonthTwoSelected = false),
              (this.isMonthThreeSelected = false)))
          : "";
  }

  allowonlynumber(e: any) {
    this.isdayfrequencyEmpty = false;
    this.isweekfrequencyEmpty = false;
    this.ismonthfrequencyEmpty = false;
    this.isyearfrequencyEmpty = false;

    e.target.value = e.target.value.replace(/[^0-9]/g, "");
    this.dayfrequency = e.target.value;
    this.weekfrequency = e.target.value;
    this.monthfrequency = e.target.value;
    this.yearfrequency = e.target.value;
  }

  dayOneEvent(e: any) {
    e.target.checked === true
      ? ((this.isDayOneSelected = true), (this.isDayTwoSelected = false))
      : (this.isDayOneSelected = false);
  }

  dayTwoEvent(e: any) {
    this.dayfrequency = "";
    e.target.checked === true
      ? ((this.isDayTwoSelected = true), (this.isDayOneSelected = false))
      : (this.isDayTwoSelected = false);
  }

  weekOneEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekOneSelected = true), (this.isWeekTwoSelected = false))
      : (this.isWeekOneSelected = false);
  }

  weekTwoEvent(e: any) {
    this.weekfrequency = "";
    this.isweekfrequencyEmpty = false;
    e.target.checked === true
      ? ((this.isWeekTwoSelected = true), (this.isWeekOneSelected = false))
      : (this.isWeekTwoSelected = false);
  }

  weekTwoMonEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoMonSelected = true),
        (this.isWeekTwoTueSelected = false),
        (this.isWeekTwoWedSelected = false),
        (this.isWeekTwoThuSelected = false),
        (this.isWeekTwoFriSelected = false),
        (this.isWeekTwoSatSelected = false),
        (this.isWeekTwoSunSelected = false))
      : (this.isWeekTwoMonSelected = false);
  }

  weekTwoTueEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoTueSelected = true),
        (this.isWeekTwoMonSelected = false),
        (this.isWeekTwoWedSelected = false),
        (this.isWeekTwoThuSelected = false),
        (this.isWeekTwoFriSelected = false),
        (this.isWeekTwoSatSelected = false),
        (this.isWeekTwoSunSelected = false))
      : (this.isWeekTwoTueSelected = false);
  }

  weekTwoWedEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoWedSelected = true),
        (this.isWeekTwoMonSelected = false),
        (this.isWeekTwoTueSelected = false),
        (this.isWeekTwoThuSelected = false),
        (this.isWeekTwoFriSelected = false),
        (this.isWeekTwoSatSelected = false),
        (this.isWeekTwoSunSelected = false))
      : (this.isWeekTwoWedSelected = false);
  }

  weekTwoThuEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoThuSelected = true),
        (this.isWeekTwoMonSelected = false),
        (this.isWeekTwoTueSelected = false),
        (this.isWeekTwoWedSelected = false),
        (this.isWeekTwoFriSelected = false),
        (this.isWeekTwoSatSelected = false),
        (this.isWeekTwoSunSelected = false))
      : (this.isWeekTwoThuSelected = false);
  }

  weekTwoFriEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoFriSelected = true),
        (this.isWeekTwoMonSelected = false),
        (this.isWeekTwoTueSelected = false),
        (this.isWeekTwoWedSelected = false),
        (this.isWeekTwoThuSelected = false),
        (this.isWeekTwoSatSelected = false),
        (this.isWeekTwoSunSelected = false))
      : (this.isWeekTwoFriSelected = false);
  }

  weekTwoSatEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoSatSelected = true),
        (this.isWeekTwoMonSelected = false),
        (this.isWeekTwoTueSelected = false),
        (this.isWeekTwoWedSelected = false),
        (this.isWeekTwoThuSelected = false),
        (this.isWeekTwoFriSelected = false),
        (this.isWeekTwoSunSelected = false))
      : (this.isWeekTwoSatSelected = false);
  }

  weekTwoTSunEvent(e: any) {
    e.target.checked === true
      ? ((this.isWeekTwoSunSelected = true),
        (this.isWeekTwoMonSelected = false),
        (this.isWeekTwoTueSelected = false),
        (this.isWeekTwoWedSelected = false),
        (this.isWeekTwoThuSelected = false),
        (this.isWeekTwoFriSelected = false),
        (this.isWeekTwoSatSelected = false))
      : (this.isWeekTwoSunSelected = false);
  }

  monthOneEvent(e: any) {
    e.target.checked === true
      ? ((this.isMonthOneSelected = true),
        ((this.isMonthTwoSelected = false),
          (this.isMonthThreeSelected = false)))
      : (this.isMonthOneSelected = false);
  }

  monthTwoEvent(e: any) {
    this.isRangeStartShown = false;
    this.isRangeEndShown = false;
    this.monthfrequency = "";
    this.ismonthfrequencyEmpty = false;
    this.yearfrequency = "";
    this.isyearfrequencyEmpty = false;

    e.target.checked === true
      ? ((this.isMonthTwoSelected = true),
        (this.isRepeatMonthSelected = true),
        ((this.isMonthOneSelected = false),
          (this.isMonthThreeSelected = false)))
      : ((this.isMonthTwoSelected = false),
        (this.isRepeatMonthSelected = false));
  }

  monthThreeEvent(e: any) {
    this.monthfrequency = "";
    this.ismonthfrequencyEmpty = false;
    this.yearfrequency = "";
    this.isyearfrequencyEmpty = false;

    e.target.checked === true
      ? ((this.isMonthThreeSelected = true),
        ((this.isMonthOneSelected = false), (this.isMonthTwoSelected = false)))
      : (this.isMonthThreeSelected = false);
  }

  monthThreeOneEvent(e: any) {
    e.target.checked === true
      ? ((this.isMonthThreeOneSelected = true),
        (this.isMonthThreeSecSelected = false),
        (this.isMonthThreeThrSelected = false),
        (this.isMonthThreefourSelected = false),
        (this.isMonthThreelastSelected = false))
      : "";
  }

  monthThreeSecEvent(e: any) {
    e.target.checked === true
      ? ((this.isMonthThreeOneSelected = false),
        (this.isMonthThreeSecSelected = true),
        (this.isMonthThreeThrSelected = false),
        (this.isMonthThreefourSelected = false),
        (this.isMonthThreelastSelected = false))
      : "";
  }

  monthThreethrEvent(e: any) {
    e.target.checked === true
      ? ((this.isMonthThreeOneSelected = false),
        (this.isMonthThreeSecSelected = false),
        (this.isMonthThreeThrSelected = true),
        (this.isMonthThreefourSelected = false),
        (this.isMonthThreelastSelected = false))
      : "";
  }

  monthThreefourEvent(e: any) {
    e.target.checked === true
      ? ((this.isMonthThreeOneSelected = false),
        (this.isMonthThreeSecSelected = false),
        (this.isMonthThreeThrSelected = false),
        (this.isMonthThreefourSelected = true),
        (this.isMonthThreelastSelected = false))
      : "";
  }

  monthThreelastEvent(e: any) {
    e.target.checked === true
      ? ((this.isMonthThreeOneSelected = false),
        (this.isMonthThreeSecSelected = false),
        (this.isMonthThreeThrSelected = false),
        (this.isMonthThreefourSelected = false),
        (this.isMonthThreelastSelected = true))
      : "";
  }

  rangeStartDate() {
    this.isRangeEndShown = false;
    this.isRangeStartShown = !this.isRangeStartShown;
  }

  rangeEndDate() {
    this.isRangeStartShown = false;
    this.isRangeEndShown = !this.isRangeEndShown;
  }

  rangeEndOnEvent(e: any) {
    e.target.checked === true
      ? ((this.isRangeEndOn = true), (this.isRangeEndAfter = false))
      : (this.isRangeEndOn = false);
  }

  rangeEndAfterEvent(e: any) {
    e.target.checked === true
      ? ((this.isRangeEndAfter = true), (this.isRangeEndOn = false))
      : (this.isRangeEndAfter = false);
  }

  particularDay(e: any) {
    e.target.checked === true
      ? ((this.isParticularDay = true), (this.isSpecifictime = false))
      : (this.isParticularDay = false);
  }

  specifictime(e: any) {
    e.target.checked === true
      ? ((this.isSpecifictime = true),
        (this.tphours = "00"),
        (this.tpminutes = "00"),
        (this.isParticularDay = false))
      : (this.isSpecifictime = false);
  }

  onChangeSeriesName() {
    this.isSeriesEmpty = false;
  }

  onChangerjdescription() {
    this.isnrjdescriptionError = false;
  }

  getMaintenanceTypeData(e: any) {
    console.log("getMaintenanceTypeData", e);

    this.mstep1 = false;
    this.mts1 = true;

    e.radio === "singleOccurrence"
      ? ((this.maintenanceSingleSelection = true),
        (this.maintenanceSeriesSelection = false))
      : e.radio === "seriesOccurrence"
        ? ((this.maintenanceSingleSelection = false),
          (this.maintenanceSeriesSelection = true))
        : "";
  }

  mSingleStep2Data(e: any) {
    console.log("mSingleStep2Data", e);
    this.mts2 = true;
    this.maintenanceSingleSelection = false;
    this.maintenanceSingleDetails = true;
    this.mSingle2Data = e;
  }

  getMEnvID(e: any) {
    this.masterEnvId = e;
  }

  fetchMEnvId(e: any) {
    this.masterEnvId = e;
  }

  mSeriesStep2Data(e: any) {
    console.log("entry 3");
    console.log("mSeriesStep2Data", e);
    this.mts2 = true;
    this.maintenanceSeriesSelection = false;
    this.maintenanceSeriesDetails = true;
    this.mSeries2Data = e;
  }

  mSingleStep3Data(e: any) {
    console.log("mSingleStep3Data", e);
    this.mSingle3Data = e;
    console.log("mSingle2Data", this.mSingle2Data);

    this.isLoadingIcon = true;

    this.mts3 = true;
    this.mts4 = true;
    this.maintenanceSingleSelection = false;
    this.maintenanceSingleDetails = false;
    this.maintenanceSingleReview = true;


    /*
    const env = this.envList.find(m => m.id == this.mSingle2Data.environment)

    if (this.mSingle2Data.mtnForAllEvn){
      
      const allEvn = {
        Description: this.mSingle2Data.description,
        LevelNumber: 1,
        ShowChild: true,
        alias: env.Environment_Name,
        categoryId: 0,
        category_Name: env.Environment_Name,
        isEdited: false,
        isEnabled: true,
        isMainteanceChecked: true,
        parentId: 0
      }

      this.mSingle2Data.systemAccess.push(allEvn);
    }
    */

    var hm = [];
    var sd = localStorage.getItem('selectedDates');
    var ds = sd.split(",");
    var sdt = ds.map((m: any) => (m = m.split("/").reverse().join("-")));
    sdt = sdt.filter(function (el) {
      return el != "";
    });



    console.log("dates selected--->" , e);


    this._restService
      .createMaintenanceSchedule(
        this.mSingle2Data.activityLabel,
        this.mSingle2Data.environment,
        this.mSingle2Data.systemAccess,
        this.mSingle2Data.description,
        sdt,
        e,
        false,
        0,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log(f),
          this.mScheduleResponse = f,
          (this.tableobj = []),
          (this.headerobj = f.maintenanceRes.headerObj),
          (this.tableobj = f.maintenanceRes.OccuranceTable),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          this.headerobj.hasOwnProperty("duration")
            ? ((hm = this.headerobj.duration.split(":")),
              (this.headerobj.hours = hm[0]),
              (this.headerobj.mins = hm[1]))
            : "",
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.startDateBefore = m.NewStart),
              (m.endDateBefore = m.NewEnd),
              (m.NewStart = this.timezoneConvert(m.NewStart)),
              (m.NewEnd = this.timezoneConvert(m.NewEnd)),
              console.log("end 16", m.startDateBefore)
            ),
          ),
          console.log("table 1", this.tableobj),
          this.tableobj.filter((m: any) =>
            SchedulerUtils.updateMaintenanceObject(m)
          ),
          console.log("table final3 ---->>>>>", this.tableobj),
          (this.isLoadingIcon = false)
        )
      );
  }

  mSeriesStep3Data(e: any) {
    var seriesDates: any = [];
    this.isLoadingIcon = true;
    // this.mts3 = true;
    // this.maintenanceSeriesSelection = false;
    // this.maintenanceSeriesDetails = false;
    // this.maintenanceSeriesReview = true;
    this.mSeries3Data = e;

    console.log("mSeriesStep2Data", this.mSeries2Data);
    console.log("mSeriesStep3Data", e);

    this._restService
      .createRecurringMaintenanceSchedule(
        this.mSeries2Data.activityLabel,
        this.mSeries2Data.environment,
        this.mSeries2Data.series,
        this.mSeries2Data.systemAccess,
        this.mSeries2Data.description,
        e.repeatType,
        e.repeatOption,
        e.range,
        e.startOption,
        e.endOption,
        this.masterEnvId
      )
      .pipe(
        catchError((e) => {
          (this.isLoadingIcon = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.response
              ? e.error.response
              : e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          console.log('f' + f),
          (this.mtnRecurringRes = f),
          (this.mts3 = true),
          (this.mts4 = true),
          (this.maintenanceSeriesSelection = false),
          (this.maintenanceSeriesDetails = false),
          (this.maintenanceSeriesReview = true),
          (this.tableobj = []),
          this.mScheduleResponse = new MaintenanceScheduleRes(),
          this.mScheduleResponse.maintenanceRes = f.RecurringRes,
          (this.headerobj = f.RecurringRes.headerObj),
          (this.tableobj = f.RecurringRes.OccuranceTable),
          this.tableobj.filter((m: any) => (m.isfold = false)),
          this.tableobj.filter((m: any, index: any) => (m.rowid = index + 1)),
          console.log("table 1", this.tableobj),

          this.tableobj.map((f: any) =>
            seriesDates.push(
              (
                new Date(f.NewStart).getDate() +
                "/" +
                (new Date(f.NewStart).getMonth() + 1) +
                "/" +
                new Date(f.NewStart).getFullYear()
              ).toString()
            )
          ),
          console.log("seriesDates", seriesDates),
          localStorage.setItem("seriesDates", seriesDates),
          localStorage.setItem("selectedDates", seriesDates),
          this.tableobj.filter(
            (m: any, index: any) => (
              (m.startDateBefore = m.NewStart),
              (m.endDateBefore = m.NewEnd),
              (m.NewStart = this.timezoneConvert(m.NewStart)),
              (m.NewEnd = this.timezoneConvert(m.NewEnd)),
              console.log("end 12", m.NewStart)
            ),
          ),
          this.tableobj.filter((m: any) =>
          ( SchedulerUtils.updateMaintenanceObject(m) )
          ),
          console.log("table final4 ---->>>>>", this.tableobj),
          (this.isLoadingIcon = false)
        )
      );
  }

  addingHoursMinutes(d: any) {
    console.log("d-->" + JSON.stringify(d));
    d.ctstartDate = this.timezoneConvert(d.startDate);
    d.ctendDate = this.timezoneConvert(d.endDate);
    d.startHour = new Date(d.ctstartDate).getHours();
    d.startMinutes = new Date(d.ctstartDate).getMinutes();
    d.endHours = new Date(d.ctendDate).getHours();
    d.endMinutes = new Date(d.ctendDate).getMinutes();
    d.position =
      parseInt(d.startHour + 1) * 70 + (parseInt(d.startMinutes) / 60) * 70;
    d.length =
      parseInt(d.endHours + 1) * 70 + (parseInt(d.endMinutes) / 60) * 70;
    d.length += (new Date(d.ctendDate).getDay() == new Date(d.ctstartDate).getDay() ? 0 : 1) * 24 * 70;
    console.log("int--->" + d.startDate + 'end-->' + d.endHours);

    if (d.length > 1748){
      this.extendMaintenanceTable = true;
    }
  }

  msingleSave() {
    this.isLoadingIcon = true;
    var count = 0;

    console.log("2---->", this.mSingle2Data);
    console.log("3---->", this.mSingle3Data);
    console.log("4---->", this.tableobj);

    let occuranceList = [];
    this.tableobj.map((m: any) =>
      occuranceList.push({
        NewStart: m.startDateBefore,
        NewEnd: m.endDateBefore,
        Status: m.Status,
        conflictMid: m.conflictMid,
        conflictSid: m.conflictSid
      })
    );

    console.log("5---->", occuranceList);

    var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) => (
        (f.start = (
          new Date(f.NewStart).getFullYear() +
          "-" +
          (new Date(f.NewStart).getMonth() + 1) +
          "-" +
          new Date(f.NewStart).getDate()
        ).toString()),
        (f.createdDate = new Date(f.NewStart).toLocaleString()),
        (f.todayDate = new Date().toLocaleString())
      )
    );


    var unique = [...new Set(this.tableobj.map((a: any) => a.start))];

    this.tableobj.length !== unique.length
      ? ((this.isLoadingIcon = false),
        (count = count + 1),
        (this.isFailure = true),
        (this.failureMessage =
          "Maintenance(s) creating date can not be duplicate"))
      : "";

    count === 0
      ? this._restService
        .saveMaintenance(
          this.mSingle2Data.environment,
          this.mSingle2Data.activityLabel,
          this.mSingle2Data.description,
          this.mSingle3Data.end.duration,
          this.mSingle2Data.systemAccess,
          occuranceList,
          this.masterEnvId,
          this.mSingle2Data.mtnForAllEvn
        )
        .pipe(
          catchError((e) => {
            (this.isLoadingIcon = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            console.log("Onload Error --->", e.error);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            (this.isSuccess = true),
            ((this.successMessage = f.StatusInfo),
              this.child.refreshScheduleTab(),
              (this.isLoadingIcon = false))
          )
        )
      : "";
  }

  mseriesSave() {
    this.isLoadingIcon = true;
    var count = 0;
    console.log("2---->", this.mSeries2Data);
    console.log("3---->", this.mSeries3Data);
    console.log("4---->", this.tableobj);
    var l = this.tableobj.length;
    var startDt = this.tableobj[0].startDateBefore;
    var endDt = this.tableobj[l - 1].endDateBefore;
    console.log("4-1---->", startDt + "---" + endDt);
    let occuranceList = [];
    this.tableobj.map((m: any) =>
      occuranceList.push({
        NewStart: m.startDateBefore,
        NewEnd: m.endDateBefore,
        Status: m.Status,
        conflictMid: m.conflictMid,
        conflictSid: m.conflictMid
      })
    );
    console.log("5---->", occuranceList);

    var d = localStorage.getItem("singleDate").split("/").reverse().join("-");
    this.tableobj.map(
      (f: any) => (
        (f.start = (
          new Date(f.NewStart).getFullYear() +
          "-" +
          (new Date(f.NewStart).getMonth() + 1) +
          "-" +
          new Date(f.NewStart).getDate()
        ).toString()),
        (f.createdDate = new Date(f.NewStart).toLocaleString()),
        (f.todayDate = new Date().toLocaleString())
      )
    );

    var unique = [...new Set(this.tableobj.map((a: any) => a.start))];

    this.tableobj.length !== unique.length
      ? ((this.isLoadingIcon = false),
        (count = count + 1),
        (this.isFailure = true),
        (this.failureMessage =
          "Maintenance(s) creating date can not be duplicate"))
      : "";

    this.tableobj.map((f: any) =>
      new Date(f.createdDate).getTime() < new Date(f.todayDate).getTime()
        ? ((this.isLoadingIcon = false),
          (count = count + 1),
          (this.isFailure = true),
          (this.failureMessage =
            "Maintenance(s) creating date should be greater than current date & time"))
        : ""
    );

    count === 0
      ? this._restService
        .saveRecMaintenance(
          this.mSeries2Data.environment,
          this.mSeries2Data.activityLabel,
          this.mSeries2Data.description,
          this.mSeries2Data.series,
          this.mSeries3Data.repeatType,
          startDt,
          endDt,
          this.mSeries2Data.systemAccess,
          this.mSeries3Data.endOption.duration,
          occuranceList,
          this.masterEnvId,
          this.mSeries2Data.mtnForAllEvn
        )
        .pipe(
          catchError((e) => {
            (this.isLoadingIcon = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            console.log("Onload Error --->", e.error);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            (this.isSuccess = true),
            ((this.successMessage = f.response),
              this.child.refreshScheduleTab(),
              (this.isLoadingIcon = false))
          )
        )
      : "";
  }

  gobacktostep1() {
    this.mstep1 = true;
    this.mts1 = false;
    this.maintenanceSingleSelection = false;
    this.maintenanceSeriesSelection = false;
  }

  gobacktostep2() {
    this.mstep1 = false;
    this.mts2 = false;
    this.maintenanceSingleSelection = true;
    this.maintenanceSingleDetails = false;
  }

  gobacktostep3() {
    this.mstep1 = false;
    this.mts3 = false;
    this.mts4 = false;
    this.maintenanceSingleSelection = false;
    this.maintenanceSingleDetails = true;
    this.maintenanceSingleReview = false;
  }

  gobacktoSeriesStep1() {
    this.mstep1 = true;
    this.mts1 = false;
    this.maintenanceSeriesSelection = false;
  }

  gobacktoSeriesStep2() {
    this.mstep1 = false;
    this.mts2 = false;
    this.maintenanceSeriesSelection = true;
    this.maintenanceSeriesDetails = false;
  }

  gobacktoSeriesStep3() {
    this.mstep1 = false;
    this.mts2 = true;
    this.mts3 = false;
    this.mts4 = false;
    this.maintenanceSeriesSelection = false;
    this.maintenanceSeriesDetails = true;
    this.maintenanceSeriesReview = false;
  }

  // ------------------------------------------------------------------

  // Configuration code starts
  activeDirectoryEvent(e: any) {
    this.isUrlEmpty = false;
    this.isBasednEmpty = false;
    this.isUsernameEmpty = false;
    this.isPasswordEmpty = false;
    this.isOktatokenEmpty = false;
    this.isOktaorgurlEmpty = false;
    this.url = "";
    this.basedn = "";
    this.username = "";
    this.password = "";
    this.oktaorgurl = "";
    this.oktatoken = "";

    e.target.checked === true
      ? ((this.activeDictorySelected = true), (this.oktaSelected = false))
      : (this.activeDictorySelected = false);
  }

  oktaEvent(e: any) {
    this.isUrlEmpty = false;
    this.isBasednEmpty = false;
    this.isUsernameEmpty = false;
    this.isPasswordEmpty = false;
    this.isOktatokenEmpty = false;
    this.isOktaorgurlEmpty = false;
    this.url = "";
    this.basedn = "";
    this.username = "";
    this.password = "";
    this.oktaorgurl = "";
    this.oktatoken = "";

    e.target.checked === true
      ? ((this.oktaSelected = true), (this.activeDictorySelected = false))
      : (this.oktaSelected = false);
  }

  onChangeCardNumber(e: any) {
    this.isFailure = false;

    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.cardnumber = ""),
        (this.isCardNumberEmpty = true))
      : (this.isCardNumberEmpty = false);
  }

  onChangeMonthYear(e: any) {
    this.isFailure = false;

    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.expireDate = ""),
        (this.isexpireDateEmpty = true))
      : (this.isexpireDateEmpty = false);
  }

  onChangeCCV(e: any) {
    this.isFailure = false;

    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""), (this.cvv = ""), (this.iscvvEmpty = true))
      : ((this.iscvvEmpty = false),
        (this.cvv = e.target.value.replace(/[^0-9]/g, "").trim()));
  }

  saveCreditCardDetails() {
    this.initiatePayment.next(true);
  }

  acceptMoveForward() {
    localStorage.setItem("LastLogin", "done");
    this.islastLogin = false;
    localStorage.getItem("isCardInfoProvided") === "1"
      ? (this.isCardModelShown = false)
      : (this.isCardModelShown = true);

    console.log("this.islastLogin", this.islastLogin);
    console.log("this.isCardModelShown", this.isCardModelShown);
  }

  onChangeUrl(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""), (this.url = ""), (this.isUrlEmpty = true))
      : (this.isUrlEmpty = false);
  }

  onChangeBasedn(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""), (this.basedn = ""), (this.isBasednEmpty = true))
      : (this.isBasednEmpty = false);
  }

  onChangeUsername(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.username = ""),
        (this.isUsernameEmpty = true))
      : (this.isUsernameEmpty = false);
  }

  onChangePassword(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.password = ""),
        (this.isPasswordEmpty = true))
      : (this.isPasswordEmpty = false);
  }

  adirAdminSetup() {
    this.url === "" ? (this.isUrlEmpty = true) : (this.isUrlEmpty = false);
    this.basedn === ""
      ? (this.isBasednEmpty = true)
      : (this.isBasednEmpty = false);
    this.username === ""
      ? (this.isUsernameEmpty = true)
      : (this.isUsernameEmpty = false);
    this.password === ""
      ? (this.isPasswordEmpty = true)
      : (this.isPasswordEmpty = false);

    if (
      this.url !== "" &&
      this.basedn !== "" &&
      this.username !== "" &&
      this.password !== ""
    ) {
      this._restService
        .checkingTypeUsers(
          2,
          null,
          null,
          this.url,
          this.basedn,
          this.username,
          this.password
        )
        .pipe(
          catchError((e) => {
            console.log("err --->", e);
            this.isADFailure = true;
            this.adFailureMessage = e.error.StatusInfo;
            return e;
          })
        )
        .subscribe(
          (data: any) => (
            localStorage.setItem("isSetUpInfoProvided", "1"),
            (this.isSetUpModelShown = false)
          )
        );
    }
  }

  onChangeOktaorgurl(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.oktaorgurl = ""),
        (this.isOktaorgurlEmpty = true))
      : (this.isOktaorgurlEmpty = false);
  }

  onChangeOktatoken(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.oktatoken = ""),
        (this.isOktatokenEmpty = true))
      : (this.isOktatokenEmpty = false);
  }

  cancelActiveDirectoryModal(){
    this.isSetUpModelShown = false;
    localStorage.setItem("isSetUpInfoProvided", "1");
  }

  oktaAdminSetup() {
    this.oktatoken === ""
      ? (this.isOktatokenEmpty = true)
      : (this.isOktatokenEmpty = false);
    this.oktaorgurl === ""
      ? (this.isOktaorgurlEmpty = true)
      : (this.isOktaorgurlEmpty = false);

    if (this.oktatoken !== "" && this.oktaorgurl !== "") {
      this._restService
        .checkingTypeUsers(
          1,
          this.oktatoken,
          this.oktaorgurl,
          null,
          null,
          null,
          null
        )
        .pipe(
          catchError((e) => {
            console.log("err --->", e);
            this.isOktaFailure = true;
            this.oktaFailureMessage = e.error.StatusInfo;
            return e;
          })
        )
        .subscribe(
          (data: any) => (
            localStorage.setItem("isSetUpInfoProvided", "1"),
            (this.isSetUpModelShown = false)
          )
        );
    }
  }

  convertToTimezone1(d: any) {
    var dt = new Date(d);
    var offset = dt.getTimezoneOffset();
    dt.setMinutes(dt.getMinutes() - offset);

    var timezone: any = parseInt(localStorage.getItem("localOffset"));
    var local: any = parseInt(localStorage.getItem("timezone"));

    console.log("timezone", offset, timezone);

    if (Math.abs(offset) === Math.abs(timezone)) {
      let mz = (new Date(dt.setMinutes(dt.getMinutes() - local)));
      console.log("trueeeeeeee" + mz);
      return (
        mz.getFullYear().toString().padStart(4, "0") +
        "-" +
        (mz.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        mz.getDate().toString().padStart(2, "0") +
        " " +
        mz.getHours().toString().padStart(2, "0") +
        ":" +
        mz.getMinutes().toString().padStart(2, "0") +
        ":" +
        mz.getSeconds().toString().padStart(2, "0")
      );
    } else {
      console.log("falseeeeeee");
      return d;
    }
  }

  timezoneConvert(dt) {
    console.log("entry--->", dt)
    const d = new Date(dt);
    var timeZoneFromDB: any = localStorage.getItem('timezoneName');
    let timezone = moment.tz(d, timeZoneFromDB).format("YYYY-MM-DD HH:mm:ss");
    return timezone;
  }

  onSave(){
    this.child.refreshScheduleTab();
    this.closeJobModelShown();
    this.closeMaintenanceModelShown();
  }
}
